var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let InputButton = class InputButton {
            constructor() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmClick: '@',
                    qmColor: '@',
                    qmIcon: '@',
                    qmTooltip: '@',
                    qmHref: '@',
                    qmStyle: '@'
                };
                this.templateUrl = 'Input/Button';
            }
        };
        InputButton = __decorate([
            QMC.Directive('QMC.Input', 'qmInputButton', [])
        ], InputButton);
        Input.InputButton = InputButton;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputCheckbox = class qmInputCheckbox {
            constructor() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmId: '@',
                    qmChange: '@',
                    qmTooltip: '@',
                    qmColor: '@',
                    qmLabelLeft: '@',
                    qmDisabled: '='
                };
                this.templateUrl = 'Input/Checkbox';
                this.link = (scope, element, attrs) => {
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    let lastState = !scope.qmModel;
                    scope.dependedToggle = function () {
                        if (scope.qmDisabled)
                            return;
                        if (!scope.qmLabel || scope.qmLabel.length == 0)
                            return;
                        if (lastState == scope.qmModel)
                            scope.qmModel = !scope.qmModel;
                        lastState = scope.qmModel;
                    };
                    scope.toggle = function () {
                        if (scope.qmDisabled)
                            return;
                        scope.qmModel = !scope.qmModel;
                    };
                    if (scope.qmColor != (null || undefined)) {
                        element.find('.squaredThree').children("label").css("border", "1px solid " + scope.qmColor);
                        if (scope.qmColor.toLowerCase() == '#ffffff')
                            element.find('.squaredThree').children("label").css("border", "1px solid lightgrey");
                        scope.$watch('qmModel', function (oldVal, newVal) {
                            if (scope.qmModel)
                                element.find('.squaredThree').children("label").css("background", scope.qmColor);
                            else {
                                if (scope.qmColor.toLowerCase() != '#ffffff') {
                                    element.find('.squaredThree').children("label").css("background", "white");
                                    element.find('.squaredThree').children("label").css("background-image", "unset");
                                }
                                else {
                                    element.find('.squaredThree').children("label").css("background", "lightgrey");
                                    element.find('.squaredThree').children("label").css("background-image", "repeating-linear-gradient(135deg, transparent, transparent 5px, rgba(255,255,255,.5)5px, rgba(255,255,255,.5) 10px");
                                }
                            }
                        });
                    }
                };
            }
        };
        qmInputCheckbox = __decorate([
            QMC.Directive('QMC.Input', 'qmInputCheckbox', [])
        ], qmInputCheckbox);
        Input.qmInputCheckbox = qmInputCheckbox;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        const dateFormat = 'DD.MM.YYYY';
        const GC_PARAMSPEZIAL_HEUTE = 1;
        const GC_PARAMSPEZIAL_ANFANG_DES_MONATS = 2;
        const GC_PARAMSPEZIAL_ENDE_DES_MONATS = 3;
        const GC_PARAMSPEZIAL_ANFANG_DES_JAHRES = 4;
        const GC_PARAMSPEZIAL_ENDE_DES_JAHRES = 5;
        const GcSpecialParam_BeginLastMonth = 10;
        const GcSpecialParam_EndLastMonth = 11;
        const GcSpecialParam_BeginNextMonth = 12;
        const GcSpecialParam_EndNextMonth = 13;
        const GcSpecialParam_BeginLastYear = 20;
        const GcSpecialParam_EndLastYear = 21;
        const GcSpecialParam_BeginNextYear = 22;
        const GcSpecialParam_EndNextYear = 23;
        const GcSpecialParam_BeginQ1 = 30;
        const GcSpecialParam_EndQ1 = 31;
        const GcSpecialParam_BeginQ2 = 32;
        const GcSpecialParam_EndQ2 = 33;
        const GcSpecialParam_BeginQ3 = 34;
        const GcSpecialParam_EndQ3 = 35;
        const GcSpecialParam_BeginQ4 = 36;
        const GcSpecialParam_EndQ4 = 37;
        function getSpecialValueId(target, period, num, startOrEndOf) {
            var _a;
            switch (target) {
                case 'today':
                    return GC_PARAMSPEZIAL_HEUTE;
                case 'start':
                    if (period === 'month')
                        return GC_PARAMSPEZIAL_ANFANG_DES_MONATS;
                    if (period === 'year')
                        return GC_PARAMSPEZIAL_ANFANG_DES_JAHRES;
                    break;
                case 'end':
                    if (period === 'month')
                        return GC_PARAMSPEZIAL_ENDE_DES_MONATS;
                    if (period === 'year')
                        return GC_PARAMSPEZIAL_ENDE_DES_JAHRES;
                    break;
                case 'prev':
                    if (period === 'month')
                        return startOrEndOf === 'end' ? GcSpecialParam_EndLastMonth : GcSpecialParam_BeginLastMonth;
                    if (period === 'year')
                        return startOrEndOf === 'end' ? GcSpecialParam_EndLastYear : GcSpecialParam_BeginLastYear;
                    break;
                case '?':
                    if (period === 'month')
                        return startOrEndOf === 'end' ? GC_PARAMSPEZIAL_ENDE_DES_MONATS : GC_PARAMSPEZIAL_ANFANG_DES_MONATS;
                    if (period === 'year')
                        return startOrEndOf === 'end' ? GC_PARAMSPEZIAL_ENDE_DES_JAHRES : GC_PARAMSPEZIAL_ANFANG_DES_JAHRES;
                    if (period === 'quarter') {
                        const quarterIds = startOrEndOf === 'end'
                            ? [GcSpecialParam_EndQ1, GcSpecialParam_EndQ2, GcSpecialParam_EndQ3, GcSpecialParam_EndQ4]
                            : [GcSpecialParam_BeginQ1, GcSpecialParam_BeginQ2, GcSpecialParam_BeginQ3, GcSpecialParam_BeginQ4];
                        return (_a = quarterIds[num - 1]) !== null && _a !== void 0 ? _a : null;
                    }
                    break;
                case 'next':
                    if (period === 'month')
                        return startOrEndOf === 'end' ? GcSpecialParam_EndNextMonth : GcSpecialParam_BeginNextMonth;
                    if (period === 'year')
                        return startOrEndOf === 'end' ? GcSpecialParam_EndNextYear : GcSpecialParam_BeginNextYear;
                    break;
                case 'targetMonth':
                    return null;
            }
            return null;
        }
        let qmInputDate = class qmInputDate {
            constructor($qui) {
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.dateIsDeleted = false;
                this.clearDate = true;
                this.scope = {
                    qmInit: '=',
                    qmModel: '=',
                    qmDisplayModel: '@',
                    qmStartDate: '=',
                    qmEndDate: '=',
                    qmPlaceholder: '@',
                    qmInvalidDate: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmRequired: '=',
                    qmDisabled: '=',
                    qmId: '=?',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmDisableDropDown: '@',
                    qmSpecialValue: '=?'
                };
                this.templateUrl = () => {
                    return (new qmDeviceSet()).isMobile() ? 'Input/Mobile/Date' : 'Input/Date';
                };
                this.link = (scope, element, attrs) => {
                    const tracksSpecialValue = angular.isDefined(attrs.qmSpecialValue);
                    const clearSpecialValue = () => {
                        if (tracksSpecialValue)
                            scope.qmSpecialValue = null;
                    };
                    const applySpecialValueFromMenu = (target, period, num) => {
                        if (!tracksSpecialValue)
                            return;
                        scope.qmSpecialValue = getSpecialValueId(target, period, num, scope.startOrEndOf);
                    };
                    const updateDatepickerFromMenu = (date) => {
                        if (!mobile || mobile.length === 0) {
                            element.find(".input-group.date").datepicker('update', date.toDateString());
                        }
                    };
                    const setDateFromSpecialMenu = (date) => {
                        scope._dateSetFromSpecialMenu = true;
                        scope.qmModel = date;
                        updateDatepickerFromMenu(date);
                    };
                    if (!scope.qmId || scope.qmId === 'd.id') {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    const mobile = (new qmDeviceSet()).isMobile();
                    function getRandomInt(min, max) {
                        return Math.floor(Math.random() * (max - min + 1)) + min;
                    }
                    scope.deleteDate = () => {
                        scope.qmModel = null;
                        scope.qmDisplayModel = null;
                        clearSpecialValue();
                        if (scope.qmRequired) {
                            this.dateIsDeleted = true;
                            scope.qmInvalidDate = true;
                        }
                    };
                    this.dateIsDeleted = false;
                    scope.qmInvalidDate = false;
                    element.attr("id", "date-" + getRandomInt(1, 999));
                    element.id = "date-" + getRandomInt(1, 999);
                    if (mobile.length === 0) {
                        scope.$watch('qmStartDate', () => {
                            if (scope.qmStartDate) {
                                element.find('.input-group.date').datepicker('setStartDate', scope.qmStartDate);
                                scope.clearDate = false;
                            }
                        });
                        scope.$watch('qmEndDate', () => {
                            if (scope.qmEndDate)
                                element.find('.input-group.date').datepicker('setEndDate', scope.qmEndDate);
                        });
                        scope.$watch('qmModel', (newVal, oldVal) => {
                            const fromSpecialMenu = scope._dateSetFromSpecialMenu === true;
                            if (fromSpecialMenu)
                                scope._dateSetFromSpecialMenu = false;
                            else if (tracksSpecialValue
                                && scope.qmSpecialValue != null
                                && oldVal !== undefined
                                && (oldVal == null || newVal == null || !moment(newVal).isSame(moment(oldVal), 'day'))) {
                                clearSpecialValue();
                            }
                            if (scope.qmModel) {
                                scope._syncingDisplayFromModel = true;
                                scope.qmDisplayModel = moment(scope.qmModel).format(dateFormat);
                                this.$qui.scopeApply(scope);
                                this.dateIsDeleted = false;
                                scope.qmInvalidDate = false;
                            }
                            else {
                                scope.qmDisplayModel = null;
                            }
                        });
                        scope.$watch('qmDisplayModel', (newVal, oldVal) => {
                            if (newVal === oldVal || (!newVal && !oldVal))
                                return;
                            if (scope._syncingDisplayFromModel) {
                                scope._syncingDisplayFromModel = false;
                                return;
                            }
                            if (newVal && newVal.length) {
                                const input = moment(scope.qmDisplayModel, dateFormat);
                                if (input.isValid() && !moment(scope.qmModel).isSame(input, 'day')) {
                                    scope.qmModel = input.toDate();
                                    this.dateIsDeleted = false;
                                    scope.qmInvalidDate = false;
                                    clearSpecialValue();
                                }
                                else if (!input.isValid()) {
                                    scope.deleteDate();
                                }
                            }
                        });
                        /* Ahrrr! Datepicker ahoi */
                        element.find(".input-group.date").datepicker({
                            todayBtn: "linked",
                            todayHighlight: true,
                            format: {
                                toDisplay: (date, format, language) => {
                                    // DAA-3775 what is this, why was it here?
                                    //scope.qmModel = moment(date).hours(2).toDate();
                                    return moment(date).format(dateFormat);
                                },
                                toValue: (date, format, language) => {
                                    return date;
                                }
                            },
                            keyboardNavigation: false,
                            forceParse: false,
                            calendarWeeks: true,
                            language: 'de',
                            autoclose: true,
                            orientation: "bottom auto"
                        }).on('changeDate', function (data) {
                            scope.qmInvalidDate = false;
                            this.dateIsDeleted = false;
                            const fromSpecialMenu = scope._dateSetFromSpecialMenu === true;
                            scope._dateSetFromSpecialMenu = false;
                            if (moment(data.date, dateFormat).isValid()) {
                                if (!fromSpecialMenu)
                                    clearSpecialValue();
                                scope.qmDisplayModel = moment(data.date).format(dateFormat);
                                if (scope.qmStartDate && moment(data.date, dateFormat).isBefore(scope.qmStartDate))
                                    scope.qmDisplayModel = moment(scope.qmStartDate).format(dateFormat);
                                if (scope.qmEndDate && moment(data.date, dateFormat).isAfter(moment(scope.qmEndDate).endOf('day')))
                                    scope.qmDisplayModel = moment(scope.qmEndDate).format(dateFormat);
                                scope.qmModel = moment(data.date, dateFormat).toDate();
                            }
                            else if (scope.qmDisplayModel && scope.qmDisplayModel.length === 0) {
                                scope.deleteDate();
                            }
                            else {
                                scope.qmInvalidDate = true;
                                scope.qmModel = null;
                            }
                            element.find(".input-group.date").datepicker('hide');
                        }).on('clearDate', function (data) {
                            //somehow the clearDate event is triggered when the qmStartDate is changed, better handling the clearDate event using a variable that tells the event if the user really wants to clear the date
                            if (scope.clearDate) {
                                this.dateIsDeleted = true;
                                if (scope.qmRequired === true) {
                                    scope.qmInvalidDate = true;
                                    //keep the datePicker Calender opened so the user can still choose a date, in case they accidentaly pressed delete, the date is required, the user must select a date
                                }
                                else {
                                    element.find(".input-group.date").datepicker('hide');
                                }
                            }
                            scope.clearDate = true;
                        });
                        if (!scope.qmStartDate)
                            element.find('.input-group.date').datepicker('setStartDate', new Date(1753, 1, 1));
                        if (!scope.qmEndDate)
                            element.find('.input-group.date').datepicker('setEndDate', new Date(9999, 12, 31));
                    }
                    else {
                        scope.$watch('qmModel', () => {
                            if (scope.qmModel) {
                                scope.qmModel.setSeconds(0);
                                scope.qmModel.setMilliseconds(0);
                            }
                            this.$qui.scopeApply(scope);
                        });
                    }
                    // HOTKEY HANDLING FROM HERE DOWN
                    scope.waitCounter = 0;
                    scope.waitForInit = () => {
                        const ele = document.getElementById(scope.qmId);
                        if (ele) {
                            document.getElementById(scope.qmId).onkeydown = (event) => {
                                let date = scope.qmModel;
                                if (!date)
                                    date = new Date();
                                switch (event.keyCode) {
                                    case 33: //pageUp, set start of Month
                                        clearSpecialValue();
                                        if (event.shiftKey) { //year insted of month
                                            scope.qmModel = getStartEndDate(date, 'year', false);
                                        }
                                        else {
                                            scope.qmModel = getStartEndDate(date, 'month', false);
                                        }
                                        event.preventDefault();
                                        break;
                                    case 34: //pageDown, set end of Month
                                        clearSpecialValue();
                                        if (event.shiftKey) { //year insted of month
                                            scope.qmModel = getStartEndDate(date, 'year', true);
                                        }
                                        else {
                                            scope.qmModel = getStartEndDate(date, 'month', true);
                                        }
                                        event.preventDefault();
                                        break;
                                    case 8: //delete button
                                        element.find(".input-group.date").datepicker('update', '');
                                        this.dateIsDeleted = true;
                                        if (scope.qmRequired === true) {
                                            scope.qmInvalidDate = true;
                                            scope.qmModel = null;
                                            //keep the datePicker Calender opened so the user can still choose a date, in case they accidentaly pressed delete, the date is required, the user must select a date
                                        }
                                        else {
                                            element.find(".input-group.date").datepicker('hide');
                                        }
                                        break;
                                    default:
                                        break;
                                }
                                this.$qui.scopeApply(scope);
                            };
                        }
                        else if (scope.waitCounter < 25) {
                            setTimeout(() => {
                                scope.waitForInit();
                                scope.waitCounter++;
                            }, 250);
                        }
                    };
                    scope.waitForInit();
                    const getStartEndDate = (date, periodType, toEnd) => {
                        var next;
                        if (toEnd)
                            next = moment(date).endOf(periodType).toDate();
                        else
                            next = moment(date).startOf(periodType).toDate();
                        if (next.toString() === date.toString()) {
                            if (toEnd)
                                next = moment(date).add(1, periodType + 's').toDate();
                            else
                                next = moment(date).add(-1, periodType + 's').toDate();
                        }
                        // make sure to really be at the end of period after adding
                        if (toEnd)
                            next = moment(next).endOf(periodType).toDate();
                        return next;
                    };
                    // CONTEXT HANDLING FROM HERE DOWN
                    scope.openSubMenu = () => {
                        const menu = document.getElementById('dd' + scope.qmId);
                        const dp = element.find('.input-group.date');
                        const input = document.getElementById(scope.qmId);
                        if (scope.qmDisableDropDown || !menu || !dp || scope.qmDisabled || input.hasAttribute('disabled'))
                            return;
                        if (!mobile || mobile.length === 0) {
                            setTimeout(() => {
                                dp.datepicker('hide');
                            });
                        }
                        scope.openDD('dd');
                    };
                    scope.setDate = (target, period, num) => {
                        if (target === '?')
                            target = scope.startOrEndOf;
                        if (period === 'quarter') {
                            switch (num) {
                                case 1:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('01/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('03/31/' + moment().get('year'));
                                    break;
                                case 2:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('04/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('06/30/' + moment().get('year'));
                                    break;
                                case 3:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('07/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('09/30/' + moment().get('year'));
                                    break;
                                case 4:
                                    if (scope.startOrEndOf !== 'end')
                                        scope.qmModel = new Date('10/01/' + moment().get('year'));
                                    else
                                        scope.qmModel = new Date('12/31/' + moment().get('year'));
                                    break;
                            }
                            // if new date exceeds min/max bounds cap it there
                            if (scope.qmStartDate && moment(scope.qmStartDate).isAfter(scope.qmModel))
                                scope.qmModel = scope.qmStartDate;
                            if (scope.qmEndDate && moment(scope.qmEndDate).isBefore(scope.qmModel))
                                scope.qmModel = scope.qmEndDate;
                            applySpecialValueFromMenu('?', 'quarter', num);
                            scope.qmInvalidDate = false;
                            setDateFromSpecialMenu(scope.qmModel);
                            return;
                        }
                        var result;
                        switch (target) {
                            case 'today':
                                result = new Date();
                                break;
                            case 'start':
                                result = getStartEndDate(new Date(), period, false);
                                break;
                            case 'end':
                                result = getStartEndDate(new Date(), period, true);
                                break;
                            case 'prev':
                                result = getStartEndDate(moment().set(period, moment().get(period) - 1), period, scope.startOrEndOf === 'end');
                                break;
                            case 'next':
                                result = getStartEndDate(moment().set(period, moment().get(period) + 1), period, scope.startOrEndOf === 'end');
                                break;
                            case 'targetMonth':
                                var temp = moment(scope.qmModel ? scope.qmModel : new Date());
                                temp = temp.set('year', scope.shortcutYear);
                                temp = temp.set('month', num);
                                // scope.qmModel = getStartEndDate(temp.toDate(), 'month', scope.startOrEndOf === 'end');
                                if (scope.startOrEndOf === 'end')
                                    temp = moment(temp).endOf('month');
                                else
                                    temp = moment(temp).startOf('month');
                                result = temp.toDate();
                                break;
                        }
                        // if new date exceeds min/max bounds cap it there
                        if (scope.qmStartDate && moment(scope.qmStartDate).isAfter(result))
                            result = scope.qmStartDate;
                        if (scope.qmEndDate && moment(scope.qmEndDate).isBefore(result))
                            result = scope.qmEndDate;
                        applySpecialValueFromMenu(target, period, num);
                        scope.qmInvalidDate = false;
                        // Only trigger change when date has actually changed
                        if (!scope.qmModel || (moment(scope.qmModel).toDate().toDateString() !== moment(result).toDate().toDateString()) || this.dateIsDeleted === true) {
                            setDateFromSpecialMenu(result);
                        }
                    };
                    scope.startOrEndOf = 'start';
                    scope.openStartEndOfDdn = (mode) => {
                        scope.openDD('dds');
                        scope.startOrEndOf = mode;
                    };
                    window.onclick = (event) => {
                        closeAllDropDown(false, event);
                    };
                    const closeAllDropDown = (force, event) => {
                        if (force || (event && event.target && !event.target.matches('.dropbtn') && !event.target.matches('.dontClose'))) {
                            const dropdowns = document.getElementsByClassName("date-dropdown");
                            for (var i = 0; i < dropdowns.length; i++) {
                                if (dropdowns[i].classList.contains('date-show')) {
                                    dropdowns[i].classList.remove('date-show');
                                }
                            }
                        }
                    };
                    scope.dateDropDownShurtcutYears = [];
                    scope.dateDropDownShurtcutYears.push(moment().get('year') - 1);
                    scope.dateDropDownShurtcutYears.push(moment().get('year'));
                    scope.dateDropDownShurtcutYears.push(moment().get('year') + 1);
                    scope.shortcutYear = moment().get('year');
                    scope.openShortcutYear = (year) => {
                        scope.openDD('ddy');
                        scope.shortcutYear = year;
                    };
                    scope.openDD = (ddName) => {
                        closeAllDropDown(true, null);
                        const menu = document.getElementById(ddName + scope.qmId);
                        setTimeout(() => {
                            if (menu)
                                menu.classList.toggle('date-show');
                            //try to place dropdown in visible area
                            var ancestor = element[0].parentNode.parentNode.parentNode;
                            if (scope.$parent === 'dateRange')
                                ancestor = ancestor.parentNode;
                            console.log(ancestor, ancestor.tagName, scope.$parent);
                            const containerRect = ancestor.getBoundingClientRect();
                            const lowerBound = containerRect.top + containerRect.height;
                            const menuRect = menu.firstElementChild.getBoundingClientRect();
                            const ddLowerEnd = menuRect.top + menuRect.height;
                            if (ddLowerEnd > lowerBound) {
                                menu.style.top = '-' + Math.min(ddLowerEnd - lowerBound + 15, containerRect.height) + 'px';
                            }
                            else {
                                menu.style = 'unset';
                            }
                        }, 1);
                    };
                    scope.$on('$destroy', () => {
                        if (document.getElementById(scope.qmId))
                            document.getElementById(scope.qmId).onkeydown = undefined;
                    });
                };
            }
        };
        qmInputDate = __decorate([
            QMC.Directive('QMC.Input', 'qmInputDate', ['$qui'])
        ], qmInputDate);
        Input.qmInputDate = qmInputDate;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputDateMonths = class qmInputDateMonths {
            constructor($qui, lngService) {
                this.$qui = $qui;
                this.lngService = lngService;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmDateFrom: '=',
                    qmDateTo: '=',
                    qmMonths: '=',
                    qmDisabled: '@'
                };
                this.templateUrl = 'Input/DateMonths';
                this.controller = ['$scope', ($scope) => {
                        $scope.createMonthList = () => {
                            var _a;
                            if ($scope.qmDateFrom == (null && undefined))
                                $scope.qmDateFrom = moment().startOf('month').toDate();
                            if ($scope.qmDateTo == (null && undefined))
                                $scope.qmDateTo = moment($scope.qmDateFrom).endOf('month').toDate();
                            const today = new Date();
                            $scope.monthsList = [];
                            $scope.yearList = [];
                            const monthNames = this.lngService.translate(20018519, 'Januar,Februar,März,April,Mai,Juni,Juli,August,September,Oktober,November,Dezember').split(',');
                            for (let i = 0; i < 12; i++) {
                                $scope.monthsList.push({
                                    value: moment(today).month(i).toISOString(),
                                    text: (_a = monthNames[i]) !== null && _a !== void 0 ? _a : moment.months()[i]
                                });
                            }
                            for (let i = ($scope.qmDateFrom.getFullYear() - 5); i < $scope.qmDateFrom.getFullYear() + 2; i++) {
                                $scope.yearList.push({
                                    value: i,
                                    text: i,
                                });
                            }
                            $scope.date = $scope.monthsList[$scope.qmDateFrom.getMonth()].value;
                            $scope.year = $scope.qmDateFrom.getFullYear();
                        };
                    }];
                this.link = (scope, element, attrs) => {
                    scope.createMonthList();
                    scope.changeDate = () => {
                        scope.qmDateFrom = moment(scope.date).startOf('month').year(scope.year).toDate();
                        scope.qmDateTo = moment(scope.date).endOf('month').year(scope.year).toDate();
                        if (scope.qmMonths === "year") {
                            scope.qmDateFrom = moment(scope.date).startOf('year').year(scope.year).toDate();
                            scope.qmDateTo = moment(scope.date).endOf('year').year(scope.year).toDate();
                        }
                    };
                };
            }
        };
        qmInputDateMonths = __decorate([
            QMC.Directive('QMC.Input', 'qmInputDateMonths', ['$qui', 'QmcLanguageService'])
        ], qmInputDateMonths);
        Input.qmInputDateMonths = qmInputDateMonths;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputDateRange = class qmInputDateRange {
            constructor($qui) {
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmDateFrom: '=',
                    qmDateTo: '=',
                    qmOriginalTimeFrom: '=',
                    qmOriginalTimeTo: '=',
                    qmPlaceholderDateFrom: '@',
                    qmPlaceholderDateTo: '@',
                    qmDisableTime: "=",
                    qmDisableDate: "=",
                    qmDurationInHours: '=?',
                    qmDurationInDays: '@',
                    qmLabelDateFrom: '@',
                    qmLabelDateTo: '@',
                    qmValidTime: '=?',
                    qmValidDate: '=?',
                    qmRequired: '=',
                    qmEnableTime: '=',
                    qmEnableDateTo: '=',
                    qmRoundInterval: '=',
                    qmDisplayDuration: '=',
                    qmStartDate: '=',
                    qmEndDate: '=',
                    qmDisabled: '=',
                    qmDateFromNotRequired: '=?',
                    qmStartRoundType: '=',
                    qmEndRoundType: '='
                };
                this.templateUrl = 'Input/DateRange';
                this.link = (scope, element, attrs) => {
                    scope.type = 'dateRange';
                    scope.qmValidDate = true;
                    scope.qmValidTime = true;
                    scope.qmDurationInDays = 0;
                    scope.dateFromId = '_' + Math.random().toString(36).substr(2, 9);
                    scope.dateToId = '_' + Math.random().toString(36).substr(2, 9);
                    // Loading initial values
                    if (scope.qmDateFrom) {
                        scope.dateFrom = scope.qmDateFrom;
                        scope.timeFrom = scope.qmDateFrom;
                        scope.originalTimeFrom = scope.qmOriginalTimeFrom ? scope.qmOriginalTimeFrom : scope.qmDateFrom;
                    }
                    if (scope.qmDateTo) {
                        scope.dateTo = scope.qmDateTo;
                        scope.timeTo = scope.qmDateTo;
                        scope.originalTimeTo = scope.qmOriginalTimeTo ? scope.qmOriginalTimeTo : scope.qmDateTo;
                    }
                    if (scope.qmEnableTime) {
                        scope.qmDurationInHours = 0;
                        scope.qmValidTime = true;
                    }
                    scope.createListener = () => {
                        scope.qmDateFromWatcher = scope.$watch('qmDateFrom', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            scope.removeListener();
                            scope.dateFrom = scope.qmDateFrom ? this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.timeFrom = scope.qmDateFrom ? this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.dateTo = scope.qmDateTo ? this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.timeTo = scope.qmDateTo ? this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.validate();
                        }, true);
                        scope.qmDateToWatcher = scope.$watch('qmDateTo', (newValue, oldValue) => {
                            if (newValue === oldValue)
                                return;
                            scope.removeListener();
                            scope.dateTo = scope.qmDateTo ? this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.timeTo = scope.qmDateTo ? this.$qui.createDateFromString(scope.qmDateTo) : undefined;
                            scope.dateFrom = scope.qmDateFrom ? this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.timeFrom = scope.qmDateFrom ? this.$qui.createDateFromString(scope.qmDateFrom) : undefined;
                            scope.validate();
                        }, true);
                        scope.dateFromListener = scope.$watch('dateFrom', (newValue, oldValue) => {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === null || newValue === undefined)
                                scope.dateFrom = scope.qmStartDate ? scope.qmStartDate : getCurrentDate();
                            scope.removeListener();
                            if (scope.dateTo && scope.dateFrom > scope.dateTo) {
                                scope.dateTo = scope.dateFrom;
                            }
                            if (scope.qmRequired && !scope.dateTo)
                                scope.dateTo = scope.dateFrom;
                            scope.validate();
                        });
                        scope.dateToListener = scope.$watch('dateTo', (newValue, oldValue) => {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === null || newValue === undefined)
                                scope.dateTo = scope.qmEndDate ? scope.qmEndDate : scope.qmRequired ? getCurrentDate() : null;
                            scope.removeListener();
                            if (scope.dateTo && scope.dateTo < scope.dateFrom) {
                                scope.dateFrom = scope.dateTo;
                            }
                            if (!scope.dateTo) {
                                scope.timeTo = null;
                            }
                            if (!scope.timeTo)
                                scope.timeTo = scope.dateTo;
                            scope.validate();
                        });
                        scope.timeFromListener = scope.$watch('timeFrom', (newValue, oldValue) => {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === (null || undefined))
                                scope.timeFrom = scope.qmStartDate ? scope.qmStartDate : getCurrentDate();
                            scope.removeListener();
                            scope.validate();
                        });
                        scope.timeToListener = scope.$watch('timeTo', (newValue, oldValue) => {
                            if (JSON.stringify(newValue) === JSON.stringify(oldValue))
                                return;
                            if (newValue === (null || undefined))
                                scope.timeTo = scope.qmEndDate ? scope.qmEndDate : getCurrentDate();
                            scope.removeListener();
                            scope.validate();
                        });
                    };
                    scope.createListener();
                    const getCurrentDate = () => {
                        var date = new Date();
                        date.setSeconds(0);
                        date.setMilliseconds(0);
                        return date;
                    };
                    scope.removeListener = () => {
                        scope.qmDateToWatcher();
                        scope.qmDateFromWatcher();
                        scope.dateFromListener();
                        scope.dateToListener();
                        scope.timeFromListener();
                        scope.timeToListener();
                    };
                    scope.validate = () => {
                        scope.removeListener();
                        //if any value is null set its model null
                        try {
                            /**
                             * RoundTime
                             */
                            const setTimeFrom = scope.timeFrom ? this.$qui.createDateFromString(scope.timeFrom).getHours() + ":" + this.$qui.createDateFromString(scope.timeFrom).getMinutes() : '0:0';
                            const orgTimeFrom = scope.originalTimeFrom ? this.$qui.createDateFromString(scope.originalTimeFrom).getHours() + ":" + this.$qui.createDateFromString(scope.originalTimeFrom).getMinutes() : '0:0';
                            const setTimeTo = scope.timeTo ? this.$qui.createDateFromString(scope.timeTo).getHours() + ":" + this.$qui.createDateFromString(scope.timeTo).getMinutes() : '0:0';
                            const orgTimeTo = scope.originalTimeTo ? this.$qui.createDateFromString(scope.originalTimeTo).getHours() + ":" + this.$qui.createDateFromString(scope.originalTimeTo).getMinutes() : '0:0';
                            if (scope.qmRoundInterval && setTimeFrom != orgTimeFrom) {
                                scope.timeFrom = this.$qui.roundTime(scope.timeFrom, scope.qmRoundInterval, true, scope.qmStartRoundType);
                            }
                            if (!scope.timeTo)
                                scope.timeTo = scope.dateTo;
                            if (scope.qmRoundInterval && setTimeTo != orgTimeTo) {
                                scope.timeTo = this.$qui.roundTime(scope.timeTo, scope.qmRoundInterval, true, scope.qmEndRoundType);
                            }
                            scope.dateFrom = this.$qui.addTimeToDate(scope.dateFrom, scope.timeFrom);
                            if (scope.dateTo) {
                                scope.dateTo = this.$qui.addTimeToDate(scope.qmEnableDateTo ? scope.dateTo : scope.dateFrom, scope.timeTo);
                            }
                            scope.qmDurationInDays = 0;
                            scope.qmDurationInHours = 0;
                            scope.qmValidDate = true;
                            scope.qmValidTime = true;
                            scope.qmDurationInDays = this.$qui.getDurationInDays(scope.dateFrom, scope.dateTo);
                            if (scope.qmDurationInDays < 0 && scope.qmRequired) {
                                scope.qmValidDate = false;
                            }
                            if (scope.qmDurationInDays >= 1)
                                scope.qmValidTime = true;
                            scope.qmDateFrom = this.$qui.addTimeToDate(scope.dateFrom, scope.timeFrom);
                            scope.qmDateTo = this.$qui.addTimeToDate(scope.dateTo, scope.timeTo);
                            if (!scope.qmRequired && !moment(scope.qmDateTo).isValid()) {
                                scope.qmDateTo = null;
                            }
                            setTimeout(() => {
                                if (scope.dateFrom && scope.timeFrom)
                                    scope.qmDateFrom = this.$qui.addTimeToDate(scope.dateFrom, scope.timeFrom);
                                if (scope.dateTo && scope.timeTo)
                                    scope.qmDateTo = this.$qui.addTimeToDate(scope.dateTo, scope.timeTo);
                                if (scope.qmEnableTime && (scope.qmRequiered || (scope.timeFrom && scope.timeTo))) {
                                    const duration = moment.duration(moment(scope.qmDateTo).diff(moment(scope.qmDateFrom)));
                                    scope.qmDurationInHours = isNaN(Number(duration.asHours())) ? 0 : Number(duration.asHours());
                                    scope.qmValidTime = scope.qmDurationInHours >= 0 && !isNaN(Number(duration.asHours()));
                                }
                                this.$qui.scopeApply(scope);
                                scope.createListener();
                            }, 50);
                        }
                        catch (e) {
                            console.warn('validation failed', e);
                            scope.createListener();
                        }
                    };
                    scope.removeListener();
                    scope.validate();
                    // HOTKEY HANDLING FROM HERE DOWN
                    setTimeout(() => {
                        if (scope.qmEnableDateTo && document.getElementById(scope.dateFromId) && document.getElementById(scope.dateToId)) {
                            document.getElementById(scope.dateFromId).onkeydown = (event) => {
                                setTimeout(() => {
                                    handleDateKeyEvent(event, 'from');
                                    this.$qui.scopeApply(scope);
                                }, 50);
                            };
                            document.getElementById(scope.dateToId).onkeydown = (event) => {
                                setTimeout(() => {
                                    handleDateKeyEvent(event, 'to');
                                    this.$qui.scopeApply(scope);
                                }, 50);
                            };
                        }
                    }, 500);
                    const handleDateKeyEvent = (event, source) => {
                        if (!(event.keyCode === 35 || event.keyCode === 36))
                            return;
                        event.preventDefault();
                        if (!scope.dateTo)
                            scope.dateTo = new Date();
                        const prevDate = {
                            from: scope.dateFrom,
                            to: scope.dateTo
                        };
                        let periodType = 'month';
                        if (event.shiftKey) {
                            periodType = 'year';
                        }
                        if (!event.altKey) {
                            if (event.shiftKey) {
                                scope.dateFrom = moment(scope.dateFrom).startOf('year').toDate();
                                scope.dateTo = moment(scope.dateTo).endOf('year').toDate();
                            }
                            scope.dateFrom = moment(scope.dateFrom).startOf('month').toDate();
                            scope.dateTo = moment(scope.dateTo).endOf('month').toDate();
                            if (prevDate.from.setHours(0, 0, 0, 0) === scope.dateFrom.setHours(0, 0, 0, 0) && prevDate.to.setHours(0, 0, 0, 0) === scope.dateTo.setHours(0, 0, 0, 0)) {
                                if (event.keyCode === 35) {
                                    scope.dateFrom = moment(scope.dateFrom).add(1, periodType).toDate();
                                    scope.dateTo = moment(scope.dateTo).add(1, periodType).toDate();
                                }
                                else {
                                    scope.dateFrom = moment(scope.dateFrom).add(-1, periodType).toDate();
                                    scope.dateTo = moment(scope.dateTo).add(-1, periodType).toDate();
                                }
                            }
                            // make finally sure to be at start/end of month
                            scope.dateFrom = moment(scope.dateFrom).startOf('month').toDate();
                            scope.dateTo = moment(scope.dateTo).endOf('month').toDate();
                        }
                        else {
                            // alt key pressed on  home count from one period down, on end count to up
                            if (event.keyCode === 36) {
                                scope.dateFrom = moment(scope.dateFrom).add(-1, periodType).toDate();
                            }
                            else {
                                scope.dateTo = moment(scope.dateTo).add(1, periodType).toDate();
                            }
                        }
                        this.$qui.scopeApply(scope);
                    };
                    scope.$on('$destroy', () => {
                        if (document.getElementById(scope.dateFromId))
                            document.getElementById(scope.dateFromId).onkeydown = undefined;
                        if (document.getElementById(scope.dateToId))
                            document.getElementById(scope.dateToId).onkeydown = undefined;
                    });
                };
            }
        };
        qmInputDateRange = __decorate([
            QMC.Directive('QMC.Input', 'qmInputDateRange', ['$qui'])
        ], qmInputDateRange);
        Input.qmInputDateRange = qmInputDateRange;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputFile = class qmInputFile {
            constructor(lng) {
                this.lng = lng;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmId: '@',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmDisabled: '=',
                    qmModel: '=?',
                    qmAccept: '=?'
                };
                this.templateUrl = 'Input/File';
                this.link = (scope, element, attrs) => {
                    // set defaults
                    if (!scope.qmIcon)
                        scope.qmIcon = 'fa fa-paperclip';
                    if (!scope.qmId)
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    if (!scope.qmModel)
                        scope.qmModel = [];
                    scope.data = {
                        filenames: [],
                        uploads: []
                    };
                    scope.openFileSelector = () => {
                        document.getElementById(scope.qmId).click();
                    };
                    scope.$watch('data', () => {
                        scope.addFile();
                    }, true);
                    scope.addFile = () => {
                        if (scope.data.filenames.length > 0 && scope.data.uploads.length > 0) {
                            const file = {
                                name: scope.data.filenames[0],
                                base64: scope.data.uploads[0].split(',')[1]
                            };
                            if (scope.allowedFileTypes && !scope.allowedFileTypes.split(',').some(function (x) { return x.includes(file.name.split('.').pop()); })) {
                                alert(`${this.lng.translate(20000314, 'Der ausgewählte Dateityp wird nicht unterstützt')} (${file.name.split('.').pop()}).`);
                                return;
                            }
                            scope.qmModel.push(file);
                            scope.data.filenames = [];
                            scope.data.uploads = [];
                            scope.loading = false;
                            $('#' + scope.qmId).val('');
                        }
                    };
                };
            }
        };
        qmInputFile = __decorate([
            QMC.Directive('QMC.Input', 'qmInputFile', ['QmcLanguageService'])
        ], qmInputFile);
        Input.qmInputFile = qmInputFile;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputNumber = class qmInputNumber {
            constructor($qui) {
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmRequired: '=',
                    qmMaxLength: '@',
                    qmName: '@',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmId: '=?',
                    qmClass: '@',
                    qmDisabled: '=',
                    qmMinValue: '=?',
                    qmMaxValue: '=?',
                    qmDisableDecimal: '=?',
                    qmDisplayRound: '=?'
                };
                this.templateUrl = 'Input/Number';
                this.link = (scope, element, attrs) => {
                    if (!scope.qmId || scope.qmId === 'd.id') {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    // Locale-specific decimal separator (e.g. ',' in de-DE, '.' in en-US)
                    let seperator = (1.1).toLocaleString().substring(1, 2);
                    // Normalize user input for numeric parsing (comma → dot)
                    const normalizeNumberString = (value) => {
                        return (value + '').replace(',', '.');
                    };
                    // Detects in-progress input that must not yet be converted to a number.
                    // While typing, converting to Number and back would strip meaningful zeros
                    // (e.g. "1.0" → 1 → "1", blocking "1.012"; "0.0" → 0, blocking "0.02").
                    const isPartialNumberInput = (value) => {
                        const strVal = (value + '').trim();
                        // Lone minus or trailing decimal separator: user is still typing
                        if (strVal === '-' || strVal.endsWith('.') || strVal.endsWith(',')) {
                            return true;
                        }
                        const normalized = strVal.replace(',', '.');
                        const decimalIndex = normalized.indexOf('.');
                        if (decimalIndex < 0) {
                            return false;
                        }
                        const parsed = Number(normalized);
                        if (Number.isNaN(parsed)) {
                            return false;
                        }
                        // Compare fractional digits: if round-trip loses zeros, keep raw display text
                        const inputFractional = normalized.substring(decimalIndex + 1);
                        const roundTrip = parsed.toString();
                        const roundTripDecimalIndex = roundTrip.indexOf('.');
                        const roundTripFractional = roundTripDecimalIndex >= 0
                            ? roundTrip.substring(roundTripDecimalIndex + 1)
                            : '';
                        return inputFractional !== roundTripFractional;
                    };
                    const handleMouseOver = () => {
                        scope.respectSpinner = true;
                    };
                    const handleMouseOut = () => {
                        scope.respectSpinner = false;
                    };
                    // if a max length (count of digits) is set, adjust max/min value accordingly to let browser handle it
                    if (scope.qmMaxLength) {
                        const maxLength = parseInt(scope.qmMaxLength);
                        let lengthString = '';
                        for (let i = 0; i < maxLength; i++)
                            lengthString += '9';
                        scope.qmMaxValue = scope.qmMaxValue ? Math.min(Number(lengthString), Number(scope.qmMaxValue)) : lengthString;
                        scope.qmMinValue = scope.qmMinValue ? Math.max(Number('-' + lengthString), Number(scope.qmMinValue)) : '-' + lengthString;
                    }
                    //DA-2627 done right
                    element[0].addEventListener('mouseover', handleMouseOver);
                    element[0].addEventListener('mouseout', handleMouseOut);
                    if (!scope.qmDisableDecimal || scope.qmDisableDecimal === undefined)
                        scope.qmDisableDecimal = false;
                    if (!scope.qmMinValue || scope.qmMinValue === undefined)
                        scope.qmMinValue = 0;
                    if (!scope.qmMaxLength || scope.qmMaxLength > 12) {
                        scope.qmMaxLength = 12;
                    }
                    this.$qui.waitForEl('#' + scope.qmId, () => {
                        const inputEl = $('#' + scope.qmId);
                        // input validation (keydown does not fire reliably on iOS virtual keyboards)
                        inputEl.on('keydown', (event) => {
                            var _a;
                            const key = event.originalEvent.key;
                            const currentValue = ((_a = scope.displayModel) !== null && _a !== void 0 ? _a : '') + '';
                            //for non browsers (edge, ie): replace commas with dots in real-time (for en-US locals)
                            if ((window.navigator.userAgent.indexOf("Trident") > -1 || navigator.userAgent.indexOf("Edge") > -1) && (key === ',')) {
                                event.preventDefault();
                                seperator = '.';
                                inputEl.val(inputEl.val() + ".");
                            }
                            switch (key) {
                                case '.':
                                case ',':
                                    if (scope.qmDisableDecimal || currentValue.indexOf('.') >= 0 || currentValue.indexOf(',') >= 0 || key !== seperator)
                                        event.preventDefault();
                                    break;
                                case '-':
                                    if (scope.qmMinValue > -1 || currentValue.indexOf('-') >= 0)
                                        event.preventDefault();
                                    break;
                                case 'ArrowUp':
                                case 'ArrowDown':
                                    event.preventDefault();
                                    break;
                            }
                        });
                        if (!scope.qmDisableDecimal) {
                            // 'input' fires reliably on mobile; keep partial values as display text only
                            inputEl.on('input', () => {
                                var _a, _b;
                                const rawValue = ((_a = inputEl.val()) !== null && _a !== void 0 ? _a : '') + '';
                                if (isPartialNumberInput(rawValue)) {
                                    scope.displayModel = rawValue;
                                    this.$qui.scopeApply(scope);
                                    return;
                                }
                                const normalized = normalizeNumberString(rawValue);
                                if (normalized !== '' && isNaN(Number(normalized))) {
                                    inputEl.val((_b = scope.displayModel) !== null && _b !== void 0 ? _b : '');
                                    return;
                                }
                                scope.displayModel = rawValue;
                                this.$qui.scopeApply(scope);
                            });
                        }
                    });
                    scope.$watch('qmModel', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        if (scope.qmModel === undefined || scope.qmModel === null) {
                            scope.displayModel = 0;
                            return;
                        }
                        if (typeof scope.qmModel !== 'number')
                            scope.qmModel = Number(scope.qmModel);
                        scope.blur();
                    });
                    scope.$watch('displayModel', (newVal, oldVal) => {
                        if (!newVal && scope.qmMinValue < 0) {
                            scope.qmModel = undefined;
                            return;
                        }
                        // Skip sync while typing partial decimals or when field is not actively edited
                        if (newVal === undefined || newVal === oldVal || isPartialNumberInput(newVal) || (!element.find('input').is(":focus") && !scope.respectSpinner))
                            return;
                        scope.qmModel = scope.validateNumber(scope.displayModel);
                        scope.blur();
                    });
                    scope.focus = () => {
                        if (scope.qmModel === undefined || scope.qmModel === null || Number.isNaN(scope.qmModel)) {
                            scope.displayModel = '';
                        }
                        else if (scope.qmDisableDecimal) {
                            scope.displayModel = Number(scope.qmModel + '');
                        }
                        else {
                            scope.displayModel = normalizeNumberString(scope.qmModel).replace('.', seperator);
                        }
                        element.find('input').select();
                    };
                    scope.blur = () => {
                        // Finalize partial input (e.g. "1.0") into the numeric model on leave
                        if (isPartialNumberInput(scope.displayModel)) {
                            scope.qmModel = scope.validateNumber(scope.displayModel);
                        }
                        if (Number.isNaN(scope.qmModel) || (scope.qmModel + '').length === 0) {
                            scope.displayValue = undefined;
                            return;
                        }
                        scope.displayModel = scope.qmDisableDecimal
                            ? Number(scope.qmModel)
                            : normalizeNumberString(scope.qmModel).replace('.', seperator);
                        if (scope.qmDisplayRound && !element.find('input').is(":focus")) {
                            scope.displayModel = Number(scope.qmModel.toFixed(scope.qmDisplayRound));
                        }
                        this.$qui.scopeApply(scope);
                    };
                    scope.validateNumber = (number) => {
                        if (number === undefined || number === null || number === '')
                            return 0;
                        let inputString = normalizeNumberString(number);
                        let result = Number(inputString);
                        if (Number.isNaN(result))
                            return 0;
                        // check minValue
                        if (result < Number(scope.qmMinValue + ''))
                            result = Number(scope.qmMinValue + '');
                        // check maxValue
                        if (result > Number(scope.qmMaxValue + ''))
                            result = Number(scope.qmMaxValue + '');
                        // get rid of unwanted decimals
                        if (scope.qmDisableDecimal) {
                            if (inputString.indexOf('.') > 0)
                                result = Number(inputString.substring(0, inputString.indexOf('.')));
                        }
                        return result;
                    };
                    scope.blur();
                    scope.$on('$destroy', () => {
                        element[0].removeEventListener('mouseover', handleMouseOver);
                        element[0].removeEventListener('mouseout', handleMouseOut);
                    });
                };
            }
        };
        qmInputNumber = __decorate([
            QMC.Directive('QMC.Input', 'qmInputNumber', ['$qui'])
        ], qmInputNumber);
        Input.qmInputNumber = qmInputNumber;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputPassword = class qmInputPassword {
            constructor() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmChange: '=',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmRequired: '@',
                    qmMinlength: '@',
                    qmMaxlength: '@',
                    qmDisabled: '@',
                    qmPattern: '@',
                    qmTrim: '@',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmId: '@'
                };
                this.templateUrl = 'Input/Password';
                this.link = (scope, element, attrs) => {
                    scope.isPW = true;
                    if (scope.qmId == (null || undefined)) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    if (attrs.hasOwnProperty("qmLongtext")) {
                        element.find("input").attr("maxlength", 255);
                    }
                };
            }
        };
        qmInputPassword = __decorate([
            QMC.Directive('QMC.Input', 'qmInputPassword', [])
        ], qmInputPassword);
        Input.qmInputPassword = qmInputPassword;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let InputSelect = class InputSelect {
            constructor(wvService, permissionService, lng, $qui, $timeout, userService) {
                this.wvService = wvService;
                this.permissionService = permissionService;
                this.lng = lng;
                this.$qui = $qui;
                this.$timeout = $timeout;
                this.userService = userService;
                this.restrict = 'E';
                //replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmData: '=',
                    qmId: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmClass: '@',
                    qmRequired: '=',
                    qmDisabled: '=',
                    qmPattern: '@',
                    qmTrim: '@',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmShowCheckbox: '@',
                    qmCheckboxModel: '=',
                    qmKeepEmptyGuidItems: '@',
                    qmIcon: '@',
                    qmWvId: '@',
                    qmSubWvId: '=?',
                    qmWvData: '=?',
                    qmWvValueType: '@?',
                    qmKeepOrder: '=?',
                    qmMaxDisplayItems: '@?',
                    qmMinSearchInput: '@?',
                    qmMinSearchInputThreshold: '@?',
                    appendToBody: '=?',
                    ddnPosition: '=?'
                };
                this.templateUrl = (element, attrs) => {
                    if (attrs.hasOwnProperty('multiple')) {
                        return 'Input/SelectMulti';
                    }
                    else {
                        return 'Input/Select';
                    }
                };
                this.link = (scope, element, attrs) => {
                    const windowSettingKey = 'globalSelectSettings';
                    const defaultSettings = {
                        maxDisplayItems: 50,
                        minSearchInput: 3,
                        minSearchInputThreshold: 50
                    };
                    // init search costumization
                    const setSearchParams = (settings) => {
                        var _a, _b, _c;
                        scope.maxDisplayItems = (_a = scope.qmMaxDisplayItems) !== null && _a !== void 0 ? _a : settings.maxDisplayItems;
                        scope.minSearchInput = (_b = scope.qmMinSearchInput) !== null && _b !== void 0 ? _b : settings.minSearchInput;
                        scope.minSearchInputThreshold = (_c = scope.qmMinSearchInputThreshold) !== null && _c !== void 0 ? _c : settings.minSearchInputThreshold;
                    };
                    setSearchParams(defaultSettings);
                    const getCostumizedSetting = () => {
                        if (!window[windowSettingKey]) {
                            window[windowSettingKey] = 'loading';
                            this.userService.getUserSettings(['INPUT.SELECT.MAXDISPLAYITEMS', 'INPUT.SELECT.MINSEARCHINPUT', 'INPUT.SELECT.MINSEARCHINPUTTHRESHOLD'])
                                .then(data => {
                                window[windowSettingKey] = {
                                    maxDisplayItems: data[0].value.length ? parseInt(data[0].value) : defaultSettings.maxDisplayItems,
                                    minSearchInput: data[1].value.length ? parseInt(data[1].value) : defaultSettings.minSearchInput,
                                    minSearchInputThreshold: data[2].value.length ? parseInt(data[2].value) : defaultSettings.minSearchInputThreshold
                                };
                            })
                                .catch(() => {
                                window[windowSettingKey] = defaultSettings;
                            })
                                .finally(() => setSearchParams(window[windowSettingKey]));
                        }
                        else if (window[windowSettingKey] === 'loading') {
                            setTimeout(getCostumizedSetting, 100);
                        }
                        else {
                            setSearchParams(window[windowSettingKey]);
                        }
                    };
                    getCostumizedSetting();
                    const originalPlaceholder = scope.qmPlaceholder;
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    const onSearchFocus = (event) => {
                        var _a;
                        const tip = element.find(`#${scope.qmId}-tip`);
                        if (!scope.minSearchInputThreshold || (scope.qmData && ((_a = scope.qmData) === null || _a === void 0 ? void 0 : _a.length) > scope.minSearchInputThreshold)) {
                            tip.css('display', 'unset');
                            tip.css('top', -tip.height() - 10);
                        }
                        const value = event.target.value;
                        scope.selectText = value;
                        filterAndRestrictData();
                    };
                    const onSearchBlur = () => {
                        element.find(`#${scope.qmId}-tip`).css('display', 'none');
                    };
                    const onSearchInput = (event) => {
                        const value = event.target.value;
                        scope.selectText = value;
                        filterAndRestrictData();
                    };
                    let search = element.get(0).querySelector('.ui-select-search');
                    scope.$on('$destroy', () => {
                        search = element.get(0).querySelector('.ui-select-search');
                        search.removeEventListener('focus', onSearchFocus);
                        search.removeEventListener('blur', onSearchBlur);
                        search.removeEventListener('input', onSearchInput);
                    });
                    setTimeout(() => {
                        search = element.get(0).querySelector('.ui-select-search');
                        if (attrs.hasOwnProperty('multiple') && scope.qmPlaceholder) {
                            search.setAttribute('placeholder', scope.qmPlaceholder);
                        }
                        ;
                        search.addEventListener('focus', onSearchFocus);
                        search.addEventListener('blur', onSearchBlur);
                        search.addEventListener('input', onSearchInput);
                    }, 200);
                    const filterAndRestrictData = () => {
                        this.$timeout(() => {
                            var _a, _b;
                            let search = (_a = scope.selectText) !== null && _a !== void 0 ? _a : '';
                            let data = (_b = scope.qmData) !== null && _b !== void 0 ? _b : [];
                            if (!(data === null || data === void 0 ? void 0 : data.length))
                                scope.data = []; //don't bother with empty selection
                            data = [...data].filter((item, index) => data.indexOf(item) === index); // remove duplicates
                            // on multiple select or if value is required don't offer items without value
                            if (attrs.hasOwnProperty('multiple') || scope.qmRequired)
                                data = data.filter(x => x.text && x.value !== QMC.Common.Constants.GUID_EMPTY);
                            // if minSearchInput is not reached or threshold to activate it is not reached, act like search is empty
                            if (scope.minSearchInput && search.length < scope.minSearchInput && (!scope.minSearchInputThreshold || data.length > scope.minSearchInputThreshold))
                                search = undefined;
                            // perform search
                            if (search === null || search === void 0 ? void 0 : search.length) {
                                data = data.filter(x => {
                                    var _a;
                                    //since subtext gets always converted to string array via qmData watch, we can savely assume it to be one
                                    const itemSearchText = [x.text, ...((_a = x.subText) !== null && _a !== void 0 ? _a : [])].join(';').toUpperCase();
                                    return itemSearchText.includes(search.toUpperCase());
                                });
                            }
                            // limit displayed items
                            if (scope.maxDisplayItems && data.length > scope.maxDisplayItems)
                                data = data.splice(0, scope.maxDisplayItems);
                            //always make sure, that selected items are in the result
                            let selected = scope.qmModel;
                            if (!Array.isArray(selected))
                                selected = [selected].filter(x => x); // single select only issues one item, so convert it to array
                            selected.forEach(x => {
                                if (scope.qmData && !data.some(y => x === (y === null || y === void 0 ? void 0 : y.value)))
                                    data.push(scope.qmData.find(y => y.value === x));
                            });
                            scope.data = data.filter(x => x);
                        });
                    };
                    scope.$watch('qmModel', (oldVal, newVal) => {
                        if (oldVal === newVal)
                            return;
                        filterAndRestrictData();
                    });
                    scope.$watch('qmCheckboxModel', (oldVal, newVal) => {
                        if (oldVal === newVal || scope.qmCheckboxModel === null)
                            return;
                        if (!scope.qmCheckboxModel) {
                            scope.qmModel = [];
                        }
                        else {
                            for (let i = 0; i < scope.qmData.length; i++) {
                                scope.qmModel.push(scope.qmData[i].value);
                            }
                        }
                    });
                    scope.$watch('qmData', (oldVal, newVal) => {
                        if (!scope.qmData || !Array.isArray(scope.qmData) || scope.qmKeepOrder)
                            return;
                        scope.qmData = scope.qmData.sort((a, b) => { var _a, _b; return ((_a = a.text) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.text) !== null && _b !== void 0 ? _b : ''); }, undefined, { sensitivity: 'base' }).sort((a, b) => { var _a, _b; return ((_a = a.group) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.group) !== null && _b !== void 0 ? _b : ''); }, undefined, { sensitivity: 'base' });
                        scope.qmData.forEach(data => {
                            if (!data.subText)
                                data.subText = [];
                            if (!Array.isArray(data.subText))
                                data.subText = [data.subText];
                        });
                        filterAndRestrictData();
                    });
                    /********** WV handling from here ***********/
                    scope.promptId = `prompt-${scope.qmId}`;
                    scope.promptOptions = {
                        title: this.lng.translate(20000302, "Katalogeintrag"),
                        yesNo: true,
                        icon: "qm-icon-arrow_into",
                        text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                    };
                    scope.formState = 'new';
                    const wvPermissionStorage = 'wvPermissionCache';
                    let lastValue;
                    if (scope.qmSubWvId) {
                        scope.$watch('qmSubWvId', (newVal) => {
                            if ((newVal === lastValue || !newVal) && scope.qmWvData)
                                return;
                            lastValue = newVal;
                            scope.qmData = [];
                            scope.qmWvData = undefined;
                            if (newVal !== QMC.Common.Constants.GUID_EMPTY)
                                scope.loadWv(scope.qmWvId);
                        });
                    }
                    const getPermissionType = () => {
                        const cache = window[`${wvPermissionStorage}_${scope.qmWvId}`];
                        if (!cache) {
                            window[`${wvPermissionStorage}_${scope.qmWvId}`] = 'loading';
                            this.permissionService.getPermissionsForDataset(scope.qmWvId, null).then((data) => {
                                window[`${wvPermissionStorage}_${scope.qmWvId}`] = data[0];
                            });
                        }
                    };
                    const getPermission = () => {
                        const cache = window[wvPermissionStorage];
                        const dsPerm = window[`${wvPermissionStorage}_${scope.qmWvId}`];
                        if (scope.loadWvPerm || cache === 'loading' || !dsPerm || dsPerm === 'loading') {
                            setTimeout(() => { getPermission(); }, 250);
                            return;
                        }
                        scope.loadWvPerm = true;
                        //seems like winclient dont care about catalogmanager permission at all when directly manipulating wvs so we just assume everything is true. i'll leave the old code here anyway
                        scope.newWv = dsPerm.new;
                        scope.modifyWv = dsPerm.modify;
                        scope.deleteWv = dsPerm.delete;
                        scope.viewWv = true;
                        scope.loadWvPerm = false;
                        this.$qui.scopeApply(scope);
                    };
                    if (scope.qmWvId) {
                        getPermission();
                        getPermissionType();
                    }
                    scope.initForm = () => {
                        scope.formState = 'new';
                        scope.form = {
                            id: null,
                            objectId: null,
                            comment: '',
                            name: '',
                            shortName: '',
                            value: null,
                            idReferencedObject: null,
                            isFix: false,
                            idSubtype: scope.qmWvId,
                            parentWvId: null
                        };
                        addValueConfigToForm();
                    };
                    let lastParent = undefined;
                    scope.openWv = () => {
                        if (scope.qmSubWvId && scope.qmSubWvId === QMC.Common.Constants.GUID_EMPTY) {
                            console.warn('Got a parent id but its guidempty, so the dev prop. messed up. Im not opening!');
                            return;
                        }
                        if (lastParent && lastParent !== scope.qmSubWvId) {
                            scope.qmWvData = undefined;
                        }
                        lastParent = scope.qmSubWvId;
                        if (!scope.qmWvData) {
                            scope.loadWv(scope.qmWvId);
                        }
                        else {
                            prepareData();
                        }
                        scope.formModalTitle = (scope.qmLabel && scope.qmLabel.length > 0 ? scope.qmLabel + ' - ' : '') + this.lng.translate(20000302, 'Katalogeintrag');
                        scope.tableScheme.table.Farbe.invisible = scope.qmWvValueType && scope.qmWvValueType === 'color' ? false : true;
                        $('#wvModal-' + scope.qmId).modal('show');
                    };
                    scope.loadWv = (id) => {
                        scope.wvLoad = true;
                        scope.tableScheme.data = [];
                        scope.qmPlaceholder = this.lng.translate(20000303, 'laden');
                        if (scope.qmSubWvId) {
                            if (id === '3e0d8030-1421-41b1-aed9-053d2d01a344') { //special case if subwvid is this, than it actual needs to be GuidEmpty for getting the data
                                id = QMC.Common.Constants.GUID_EMPTY;
                            }
                            this.wvService.getSubWvList(id, scope.qmSubWvId).then((data) => {
                                scope.qmWvData = data;
                                prepareData();
                            }).finally(() => {
                                scope.wvLoad = false;
                            });
                        }
                        else {
                            this.wvService.getWvList(id).then((data) => {
                                scope.qmWvData = data;
                                prepareData();
                            }).finally(() => {
                                scope.wvLoad = false;
                            });
                        }
                    };
                    const prepareData = () => {
                        markSelectedItems(scope.qmWvData);
                        scope.tableScheme.data = scope.qmWvData.filter((x) => x.objectId && x.objectId != QMC.Common.Constants.GUID_EMPTY); // Filter empty values
                        if (scope.qmWvValueType === 'color') { // format int value to hex for use with remaining components
                            for (const item of scope.qmWvData) {
                                if (item.value && (item.value + '').charAt(0) !== '#') { // value exists and does not begin with a #, therefor its not a hexcolor
                                    item.value = this.$qui.intToHex(item.value);
                                }
                            }
                        }
                        scope.qmData = scope.tableScheme.data.map(x => ({ text: x.name, value: x.objectId }));
                        if (!scope.qmRequired && !attrs.hasOwnProperty('multiple')) {
                            scope.qmData.unshift({ text: '', value: QMC.Common.Constants.GUID_EMPTY });
                        }
                        this.$qui.functionWaiter("tableScheme.createTable", scope);
                        if (scope.qmData.filter(x => x.value === scope.qmModel).length === 0)
                            scope.qmModel = null;
                        scope.qmPlaceholder = originalPlaceholder;
                    };
                    scope.setSelection = (checked, item) => {
                        const id = item.objectId ? item.objectId : item.id;
                        if (checked) {
                            if (attrs.hasOwnProperty('multiple')) {
                                scope.qmModel.push(id);
                            }
                            else {
                                scope.qmModel = id;
                                // deselect all other values
                                for (const element of scope.tableScheme.data) {
                                    element.active = id === element.objectId;
                                }
                                for (const element of scope.items) {
                                    // hacky way to actually manipulate the tables view data, replaces old way of recreating table
                                    element.undefined.selected = id === element.undefined.id;
                                }
                            }
                        }
                        else {
                            if (attrs.hasOwnProperty('multiple')) {
                                scope.qmModel = scope.qmModel.filter(x => x !== id);
                            }
                            else if (scope.qmModel === id) {
                                scope.qmModel = QMC.Common.Constants.GUID_EMPTY;
                            }
                        }
                        // when a currently selected value is updated, select-ui would not update the displayed text. To force that, we reset the selection wait a little and than put it back in :/
                        const model = scope.qmModel;
                        scope.qmModel = undefined;
                        this.$qui.scopeApply(scope);
                        this.$timeout(() => { scope.qmModel = model; }, 50);
                    };
                    const markSelectedItems = (list) => {
                        for (const item of list) {
                            if (attrs.hasOwnProperty('multiple')) {
                                item.active = scope.qmModel.some(x => x.objectId);
                            }
                            else {
                                item.active = scope.qmModel === item.objectId;
                            }
                        }
                    };
                    const formatFormValueForRequest = (form) => {
                        if (form.isColor) {
                            form.value = this.$qui.hexToInt(form.value);
                        }
                    };
                    scope.newWvEntry = () => {
                        scope.initForm();
                        $(`#edit-form-${scope.qmId}`).modal('show');
                        this.$qui.scopeApply(scope);
                    };
                    scope.postWvEntry = () => {
                        scope.wvLoad = true;
                        const form = angular.copy(scope.form);
                        formatFormValueForRequest(form);
                        if (scope.qmSubWvId)
                            this.wvService.postSubWv(form.idSubtype, scope.qmSubWvId, form).then((data) => {
                                form.id = data.createdId;
                                form.objectId = data.createdObjectId;
                                scope.setSelection(true, form);
                            }).finally(() => {
                                scope.loadWv(form.idSubtype);
                                scope.formState = 'new';
                            });
                        else
                            this.wvService.postWv(form.idSubtype, form).then((data) => {
                                form.id = data.createdId;
                                form.objectId = data.createdObjectId;
                                scope.setSelection(true, form);
                            }).finally(() => {
                                scope.loadWv(form.idSubtype);
                                scope.formState = 'new';
                            });
                    };
                    scope.editWvEntry = (data) => {
                        scope.form = data;
                        addValueConfigToForm();
                        scope.formState = 'edit';
                        $(`#edit-form-${scope.qmId}`).modal('show');
                        this.$qui.scopeApply(scope);
                    };
                    scope.putWvEntry = () => {
                        scope.wvLoad = true;
                        const form = angular.copy(scope.form);
                        formatFormValueForRequest(form);
                        if (scope.qmSubWvId)
                            this.wvService.putSubWv(form.idSubtype, scope.qmSubWvId, form.objectId, form).finally(() => {
                                scope.loadWv(form.idSubtype);
                                scope.setSelection(true, form);
                                scope.formState = 'new';
                            });
                        else
                            this.wvService.putWv(form.idSubtype, form.objectId, form).finally(() => {
                                scope.loadWv(form.idSubtype);
                                scope.setSelection(true, form);
                                scope.formState = 'new';
                            });
                    };
                    scope.deleteWvEntry = (item) => {
                        scope.promptOptions.itemText = item.name;
                        QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                            if (data) {
                                scope.wvLoad = true;
                                if (scope.qmSubWvId)
                                    this.wvService.deleteSubWv(item.idSubtype, scope.qmSubWvId, item.objectId).finally(() => {
                                        scope.loadWv(item.idSubtype);
                                    });
                                else
                                    this.wvService.deleteWv(item.idSubtype, item.objectId).finally(() => {
                                        scope.loadWv(item.idSubtype);
                                    });
                                if (attrs.hasOwnProperty('multiple')) {
                                    scope.qmModel = scope.qmModel.filter(x => x !== item.objectId);
                                }
                                else if (scope.qmModel === item.objectId) {
                                    scope.qmModel = QMC.Common.Constants.GUID_EMPTY;
                                }
                            }
                        }, '#' + scope.promptId);
                    };
                    const addValueConfigToForm = () => {
                        // use an if to not create to many useless probs in form
                        if (scope.qmWvValueType === 'color')
                            scope.form.isColor = true;
                    };
                    scope.formInvalid = () => {
                        var _a;
                        // lets get hacky :/ since we use a readymade input for the name field and it its required, a potential surrounding form would fail to validate if we just set qm-required on it
                        // thats why we add the startisk to its label by code and manually validate the 'form' (#NotAForm). tahts also the reason why the edit modal is no longer a qm-form directive.
                        const textField = (_a = element.find(`#wvName_${scope.qmId}`)[0]) === null || _a === void 0 ? void 0 : _a.children[0];
                        if (textField)
                            textField.innerHTML = this.lng.translate(20000053, 'Bezeichnung') + ' *';
                        return !scope.form || (!scope.form.name || scope.form.name.length === 0);
                    };
                    scope.tableCallback = {
                        deleteWv: scope.deleteWv,
                        deleteWvEntry: scope.deleteWvEntry,
                        modifyWv: scope.modifyWv,
                        editWvEntry: scope.editWvEntry,
                        setSelection: scope.setSelection
                    };
                    scope.tableScheme = {
                        "config": {
                            "defaultSort": "name",
                        },
                        "filter": {
                            model: null
                        },
                        "table": {
                            "Active": {
                                "id": "objectId",
                                "selected": "active",
                                "dType": "Checkbox",
                                "noHeader": true,
                                "events": {
                                    "onChange": "setSelection"
                                }
                            },
                            "Kürzel": {
                                "label": "shortName",
                                "dType": "string",
                                "lngTag": "20000221"
                            },
                            "Bezeichnung": {
                                "label": "name",
                                "dType": "string",
                                "lngTag": "20000053"
                            },
                            "Bemerkung": {
                                "label": "comment",
                                "dType": "string",
                                "lngTag": "20000049"
                            },
                            "Farbe": {
                                "label": "value",
                                "dType": "Color",
                                "lngTag": "20000300"
                            },
                            "Aktionen": [
                                {
                                    "icon": "qm-icon-pencil blue",
                                    "click": "editWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Bearbeiten",
                                    "lngTag": "20000044",
                                    "permission": "modifyWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }, {
                                    "icon": "qm-icon-garbage_can red",
                                    "click": "deleteWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Löschen",
                                    "lngTag": "20000002",
                                    "permission": "deleteWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }
                            ]
                        }, "card": {
                            "avatar": {
                                "icon": "qm-icon-arrow_into",
                            },
                            "checkbox": {
                                "selected": "active",
                                "events": {
                                    "onChange": "setSelection"
                                }
                            },
                            "text": {
                                "label": "name",
                                "dType": "string"
                            },
                            "subtext": [
                                {
                                    "label": "shortName",
                                    "dType": "string"
                                }
                            ],
                            "buttons": [
                                {
                                    "icon": "qm-icon-pencil blue",
                                    "click": "editWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Bearbeiten",
                                    "lngTag": "20000044",
                                    "permission": "modifyWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }, {
                                    "icon": "qm-icon-garbage_can red",
                                    "click": "deleteWvEntry",
                                    "label": "data",
                                    "dType": "Button",
                                    "tooltip": "Löschen",
                                    "lngTag": "20000002",
                                    "permission": "deleteWv",
                                    "events": {
                                        "hide": "isFix",
                                    }
                                }
                            ]
                        },
                        "data": null,
                    };
                };
            }
        };
        InputSelect = __decorate([
            QMC.Directive('QMC.Input', 'qmSelect', ['QmcWvService', 'QmcPermissionService', 'QmcLanguageService', '$qui', '$timeout', 'UserService'])
        ], InputSelect);
        Input.InputSelect = InputSelect;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        class SignaturePadComponent {
            constructor($qui, $window, $timeout, $element, scope) {
                this.$qui = $qui;
                this.$window = $window;
                this.$timeout = $timeout;
                this.scope = scope;
                this.isEmpty = false;
                this.EMPTY_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAAAAACwAAAAAAQABAAA=';
                this.$postLink = () => {
                    //try to prevent unwanted scrolling on canvas
                    this.canvas.addEventListener('wheel', e => e.preventDefault());
                    this.clear = () => {
                        this.signaturePad.clear();
                        this.setIsEmpty();
                    };
                    angular.element(this.$window).bind('resize', () => {
                        this.onResize();
                    });
                    this.scope.$watch("vm.height", () => {
                        this.onResize();
                    });
                    this.scope.$watch("vm.width", () => {
                        this.onResize();
                    });
                    this.scope.$watch("vm.dataurl", (dataUrl, oldVal) => {
                        if (dataUrl !== oldVal) {
                            this.signaturePad.fromDataURL(dataUrl !== null && dataUrl !== void 0 ? dataUrl : this.EMPTY_IMAGE);
                        }
                    });
                    this.setImage = (dataUrl) => {
                        this.signaturePad.fromDataURL(dataUrl !== null && dataUrl !== void 0 ? dataUrl : this.EMPTY_IMAGE);
                        this.setIsEmpty();
                    };
                    this.getImage = () => this.signaturePad.toDataURL();
                };
                this.setIsEmpty = () => {
                    this.isEmpty = this.signaturePad.isEmpty() || this.signaturePad.toDataURL() === this.EMPTY_IMAGE;
                    this.$qui.scopeApply(this.scope);
                };
                this.canvas = $element.find('canvas')[0];
                this.signaturePad = new SignaturePad(this.canvas);
                this.onResize();
                this.signaturePad.addEventListener("endStroke", () => {
                    this.setIsEmpty();
                });
            }
            onResize() {
                const prePic = this.signaturePad.toData();
                const canvasBoundingRect = this.canvas.getBoundingClientRect();
                const startWidth = this.canvas.width;
                const startHeight = this.canvas.height;
                const ratio = Math.max(this.$window.devicePixelRatio || 1, 1);
                this.canvas.width = this.canvas.offsetWidth * ratio;
                this.canvas.height = this.canvas.offsetHeight * ratio;
                this.canvas.getContext("2d").scale(ratio, ratio);
                this.signaturePad.minWidth = canvasBoundingRect.width / 300 / 1.5; //brush thickness
                this.signaturePad.maxWidth = canvasBoundingRect.width / 300 * 2; //brush thickness
                for (const stroke of prePic) {
                    stroke.minWidth = canvasBoundingRect.width / 300 / 1.5; //brush thickness
                    stroke.maxWidth = canvasBoundingRect.width / 300 * 2; //brush thickness
                    for (const point of stroke.points) {
                        point.x = point.x * (this.canvas.offsetWidth * ratio) / startWidth;
                        point.y = point.y * (this.canvas.offsetHeight * ratio) / startHeight;
                    }
                }
                this.signaturePad.fromData(prePic);
                this.setIsEmpty();
            }
            ;
        }
        //@Directive('QMC.Input', 'signaturePad', ['$qui', '$window', '$timeout'])
        angular.module('QMC.Input').component('signaturePad', {
            controller: ['$qui', '$window', '$timeout', '$element', '$scope', SignaturePadComponent],
            restrict: 'EA',
            replace: true,
            controllerAs: 'vm',
            bindings: {
                clear: '=?',
                height: '@?',
                width: '@?',
                getImage: '=?',
                setImage: '=?',
                isEmpty: '=?'
            },
            templateUrl: 'Input/SignaturePad'
        });
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
/** Debounce window for coalescing Summernote `onChange` → `ngModel` updates. */
const MODEL_SYNC_DEBOUNCE_MS = 25;
/** jQuery event namespace: codeview HTML textarea sync on keyup. */
const CODEVIEW_KEYUP_NS = 'keyup.qmSummernoteCodeview';
/** jQuery event namespace: import dropdown item clicks (prevents duplicate handlers on reopen). */
const IMPORT_DROPDOWN_CLICK_NS = 'click.qmSnImport';
const EDITOR_DESTROY_NS = '$destroy.qmSummernote';
const OPEN_MSG_MS = 250;
const MENTION_SYNC_MS = 50;
// ---------------------------------------------------------------------------
// Module-level helpers (no DI): small, pure or jQuery-only utilities
// ---------------------------------------------------------------------------
function qmBrowserWindow() {
    return globalThis;
}
/** Stable key for `fileToInsert` watcher: name + base64 length (avoids deep compare). */
function fileInsertSignature(val) {
    var _a, _b;
    const first = val === null || val === void 0 ? void 0 : val[0];
    if (!first) {
        return '';
    }
    return first.name + ':' + ((_b = (_a = first.base64) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
}
function summernoteCode($el) {
    return String($el.summernote('code'));
}
function summernoteIsEmpty($el) {
    return Boolean($el.summernote('isEmpty'));
}
function jqueryHasSummernotePlugin($el) {
    return Boolean($el && angular.isFunction($el.summernote));
}
function summernoteUi() {
    return $.summernote.ui;
}
function clampImageDimensions(width, height, settings) {
    var _a, _b;
    let w = width;
    let h = height;
    const hasW = ((_a = settings.width) !== null && _a !== void 0 ? _a : 0) > 0;
    const hasH = ((_b = settings.height) !== null && _b !== void 0 ? _b : 0) > 0;
    if (!hasW && !hasH) {
        return { width: w, height: h };
    }
    const MAX_WIDTH = hasW ? settings.width : 50000;
    const MAX_HEIGHT = hasH ? settings.height : 50000;
    if (w > MAX_WIDTH) {
        h *= MAX_WIDTH / w;
        w = MAX_WIDTH;
    }
    if (h > MAX_HEIGHT) {
        w *= MAX_HEIGHT / h;
        h = MAX_HEIGHT;
    }
    return { width: w, height: h };
}
function shrinkCanvasToApproxByteLimit(ctx, canvas, img, byteLimit, width, height) {
    let w = width;
    let h = height;
    let approxBytes = w * h * 4;
    while (approxBytes > byteLimit) {
        h *= 0.95;
        w *= 0.95;
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(img, 0, 0, w, h);
        approxBytes = w * h * 4;
    }
    return { width: w, height: h };
}
function insertResizedImageIntoEditor(element, img, settings) {
    var _a;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return;
    }
    const dims = clampImageDimensions(img.width, img.height, settings);
    canvas.width = dims.width;
    canvas.height = dims.height;
    ctx.drawImage(img, 0, 0, dims.width, dims.height);
    if (((_a = settings.size) !== null && _a !== void 0 ? _a : 0) > 0) {
        shrinkCanvasToApproxByteLimit(ctx, canvas, img, settings.size * 1048576, dims.width, dims.height);
    }
    const result = document.createElement('img');
    result.src = canvas.toDataURL();
    element.summernote('insertNode', result);
}
/**
 * Directive factory: registered on `qmc-ui` at file bottom.
 * Split: **controller** = Summernote instance + ngModel bridge; **link** = options + template scope API.
 */
function qmSummernoteDirective($languageService, $qui, userService, mediaService, $timeout) {
    return {
        restrict: 'E',
        transclude: 'element',
        replace: true,
        templateUrl: 'Input/Summernote',
        // Bindings mirror legacy directive; `qmCreate` enables lazy init when parent sets the fn.
        scope: {
            qmId: '@',
            qmSmartActions: '=',
            qmMentions: '@',
            qmParticipants: '=',
            qmClientList: '=',
            qmRequired: '@',
            qmCreate: '=?',
            qmFlush: '=?',
            qmFocus: '=?',
            qmHeight: '=',
            qmDisabled: '=',
            config: '=',
            keyup: '&onKeyup',
            keydown: '&onKeydown',
            change: '&onChange',
            qmWarning: '='
        },
        require: ['qmSummernote', '^ngModel'],
        // --- Controller: owns the Summernote DOM node passed from link (`.summernote` inside template) ---
        controller: [
            '$scope',
            '$attrs',
            '$timeout',
            function ($scope, $attrs, $timeout) {
                let currentElement;
                let summernoteConfig = {};
                /** Latest debounce canceller from `activate`; `$destroy` must not close over inner `activate` vars. */
                let cancelModelSyncDebounceRef = null;
                let cleanupActivatedBindingsRef = null;
                // Lazy global defaults; server may override via RICHTEXTIMAGES JSON.
                const w = qmBrowserWindow();
                if (!w.snResizeSettings) {
                    w.snResizeSettings = {
                        disabled: false,
                        size: 4,
                        height: 1080,
                        width: 1920
                    };
                    userService.getGlobalSettings(['RICHTEXTIMAGES']).then((data) => {
                        if (data[0].value && data[0].value.length > 0) {
                            w.snResizeSettings = JSON.parse(data[0].value);
                        }
                    });
                }
                const vm = this;
                vm.updateNgModel = null;
                vm.flush = () => { };
                vm.focus = () => { };
                /** Called once from link after first `ngModel` watch fires: merges callbacks, then `activate`. */
                vm.render = function (scope, element, ngModel, config) {
                    $scope.model = ngModel;
                    summernoteConfig = config;
                    summernoteConfig.callbacks = summernoteConfig.callbacks || {};
                    if (angular.isDefined($attrs.onKeyup)) {
                        summernoteConfig.callbacks.onKeyup = function (evt) {
                            evt.data = summernoteCode(element);
                            $scope.keyup({ evt });
                        };
                    }
                    if (angular.isDefined($attrs.onKeydown)) {
                        summernoteConfig.callbacks.onKeydown = function (evt) {
                            $scope.keydown({ evt });
                        };
                    }
                    vm.activate(scope, element, ngModel);
                };
                /**
                 * Binds Summernote, wires `ngModel.$render`, debounced `onChange`, blur flush, image pipeline,
                 * toolbar/codeview glue, and teardown on `$destroy`.
                 */
                vm.activate = function (scope, element, ngModel) {
                    // Idempotent activation: if the directive gets initialized twice, clean up old bindings first.
                    if (cleanupActivatedBindingsRef) {
                        cleanupActivatedBindingsRef();
                        cleanupActivatedBindingsRef = null;
                    }
                    let isActivated = false;
                    let debounceTimer = null;
                    /** Deferred sync so we do not call `$setViewValue` in the same turn as Summernote's internal `keyup` / Range updates. */
                    let codeviewKeyupTimer = null;
                    let unwatchNgModel;
                    let unwatchQmDisabled;
                    const cancelModelSyncDebounce = () => {
                        if (debounceTimer) {
                            $timeout.cancel(debounceTimer);
                            debounceTimer = null;
                        }
                    };
                    const cancelCodeviewKeyupSync = () => {
                        if (codeviewKeyupTimer) {
                            $timeout.cancel(codeviewKeyupTimer);
                            codeviewKeyupTimer = null;
                        }
                    };
                    cancelModelSyncDebounceRef = cancelModelSyncDebounce;
                    /** Reads `element.summernote('code')` into `ngModel` if changed (respects digest phase). */
                    function flushModelFromEditorInternal() {
                        if (!isActivated || !ngModel || $scope.summernoteDestroyed) {
                            return;
                        }
                        if (!jqueryHasSummernotePlugin(element) || element.next('.note-editor').length === 0) {
                            return;
                        }
                        let newValue;
                        try {
                            newValue = summernoteCode(element);
                            if (summernoteIsEmpty(element)) {
                                newValue = '';
                            }
                        }
                        catch (_a) {
                            return;
                        }
                        if (ngModel.$viewValue === newValue) {
                            return;
                        }
                        const set = () => {
                            if (ngModel.$viewValue === newValue) {
                                return;
                            }
                            ngModel.$setViewValue(newValue);
                        };
                        if (scope.$$phase || scope.$root.$$phase) {
                            set();
                        }
                        else {
                            scope.$evalAsync(set);
                        }
                    }
                    /** Toolbar / codeview / mentions: sync immediately and drop pending debounced `onChange`. */
                    vm.updateNgModel = function () {
                        cancelModelSyncDebounce();
                        cancelCodeviewKeyupSync();
                        flushModelFromEditorInternal();
                    };
                    vm.flush = function () {
                        cancelModelSyncDebounce();
                        cancelCodeviewKeyupSync();
                        flushModelFromEditorInternal();
                    };
                    vm.focus = function () {
                        if (!isActivated || $scope.summernoteDestroyed) {
                            return;
                        }
                        if (!jqueryHasSummernotePlugin(element) || element.next('.note-editor').length === 0) {
                            return;
                        }
                        try {
                            element.summernote('focus');
                        }
                        catch (_a) {
                            // Editor may be mid-teardown; ignore focus errors.
                        }
                    };
                    const originalOnChange = summernoteConfig.callbacks.onChange;
                    /** Consumer `&onChange` (or `originalOnChange`) runs next tick so it sees updated `ngModel`. */
                    summernoteConfig.callbacks.onChange = function () {
                        const args = arguments;
                        cancelModelSyncDebounce();
                        debounceTimer = $timeout(() => {
                            debounceTimer = null;
                            flushModelFromEditorInternal();
                            const syncContents = summernoteIsEmpty(element) ? '' : summernoteCode(element);
                            $timeout(() => {
                                if (angular.isDefined($attrs.onChange)) {
                                    $scope.change({
                                        contents: syncContents,
                                        editable: $scope.editable
                                    });
                                }
                                else if (angular.isFunction(originalOnChange)) {
                                    originalOnChange.apply(this, args);
                                }
                            }, 0);
                        }, MODEL_SYNC_DEBOUNCE_MS);
                    };
                    summernoteConfig.callbacks.onBlur = function () {
                        cancelModelSyncDebounce();
                        flushModelFromEditorInternal();
                    };
                    /** Custom upload: resize then `insertNode` (skipped when `snResizeSettings.disabled`). */
                    summernoteConfig.callbacks.onImageUpload = function (files) {
                        const img = new Image();
                        const objectUrl = URL.createObjectURL(files[0]);
                        img.src = objectUrl;
                        img.onload = function () {
                            try {
                                const settings = qmBrowserWindow().snResizeSettings;
                                if (!settings || settings.disabled) {
                                    return;
                                }
                                insertResizedImageIntoEditor(element, img, settings);
                            }
                            finally {
                                URL.revokeObjectURL(objectUrl);
                            }
                        };
                    };
                    if (jqueryHasSummernotePlugin(element) && element.next('.note-editor').length > 0 && !$scope.summernoteDestroyed) {
                        element.summernote('destroy');
                        $scope.summernoteDestroyed = true;
                    }
                    $scope.summernoteDestroyed = false;
                    element.summernote(summernoteConfig);
                    isActivated = true;
                    const editor$ = element.next('.note-editor');
                    // Toolbar click: flush model; in codeview also listen for keyup and mirror model → textarea.
                    editor$.find('.note-toolbar').on('click.qmSummernote', function () {
                        if (vm.updateNgModel) {
                            vm.updateNgModel();
                        }
                        if (editor$.hasClass('codeview')) {
                            editor$.off(CODEVIEW_KEYUP_NS).on(CODEVIEW_KEYUP_NS, () => {
                                cancelCodeviewKeyupSync();
                                codeviewKeyupTimer = $timeout(() => {
                                    codeviewKeyupTimer = null;
                                    if (!editor$.hasClass('codeview')) {
                                        return;
                                    }
                                    if (vm.updateNgModel) {
                                        vm.updateNgModel();
                                    }
                                }, 0);
                            });
                            if (ngModel) {
                                if (angular.isFunction(unwatchNgModel)) {
                                    unwatchNgModel();
                                }
                                unwatchNgModel = scope.$watch(() => ngModel.$modelValue, (newValue) => {
                                    if (!editor$.hasClass('codeview')) {
                                        return;
                                    }
                                    editor$.find('.note-codable').val(newValue);
                                });
                            }
                        }
                        else {
                            cancelCodeviewKeyupSync();
                            editor$.off(CODEVIEW_KEYUP_NS);
                            if (angular.isFunction(unwatchNgModel)) {
                                unwatchNgModel();
                                unwatchNgModel = undefined;
                            }
                        }
                    });
                    if (ngModel) {
                        ngModel.$render = function () {
                            // In codeview, avoid `summernote('code')` — it fights Summernote's selection/range handling and can throw IndexSizeError.
                            if (editor$.hasClass('codeview')) {
                                const ta = editor$.find('.note-codable');
                                if (ta.length) {
                                    ta.val(ngModel.$viewValue != null ? String(ngModel.$viewValue) : '');
                                }
                                return;
                            }
                            if (ngModel.$viewValue) {
                                element.summernote('code', ngModel.$viewValue);
                            }
                            else {
                                element.summernote('empty');
                            }
                        };
                    }
                    if (angular.isDefined($attrs.editable)) {
                        $scope.editable = editor$.find('.note-editable');
                    }
                    if (angular.isDefined($attrs.editor)) {
                        $scope.editor = element;
                    }
                    currentElement = element;
                    const cleanupActivatedBindings = () => {
                        cancelModelSyncDebounce();
                        cancelCodeviewKeyupSync();
                        editor$.find('.note-toolbar').off('click.qmSummernote');
                        editor$.off(CODEVIEW_KEYUP_NS);
                        if (angular.isFunction(unwatchNgModel)) {
                            unwatchNgModel();
                            unwatchNgModel = undefined;
                        }
                        if (angular.isFunction(unwatchQmDisabled)) {
                            unwatchQmDisabled();
                            unwatchQmDisabled = undefined;
                        }
                        if (!$scope.summernoteDestroyed && jqueryHasSummernotePlugin(element)) {
                            element.summernote('destroy');
                            $scope.summernoteDestroyed = true;
                        }
                    };
                    cleanupActivatedBindingsRef = cleanupActivatedBindings;
                    // jQuery `$destroy` on host element, namespaced for predictable unbind.
                    element.off(EDITOR_DESTROY_NS).on(EDITOR_DESTROY_NS, cleanupActivatedBindings);
                    if ($scope.qmDisabled) {
                        element.summernote('disable');
                    }
                    unwatchQmDisabled = $scope.$watch('qmDisabled', (newVal) => {
                        if (newVal) {
                            element.summernote('disable');
                        }
                        else {
                            element.summernote('enable');
                        }
                    });
                    element.parent().find('.note-editable').css('font-size', '16px');
                };
                $scope.$on('$destroy', () => {
                    vm.flush();
                    if (cancelModelSyncDebounceRef) {
                        cancelModelSyncDebounceRef();
                        cancelModelSyncDebounceRef = null;
                    }
                    if (cleanupActivatedBindingsRef) {
                        cleanupActivatedBindingsRef();
                        cleanupActivatedBindingsRef = null;
                    }
                    if (currentElement) {
                        currentElement.off(EDITOR_DESTROY_NS);
                    }
                    if (!$scope.summernoteDestroyed && jqueryHasSummernotePlugin(currentElement)) {
                        currentElement.summernote('destroy');
                        $scope.summernoteDestroyed = true;
                    }
                });
            }
        ],
        // --- Link: isolated scope API, Summernote options, file insert, smart-actions, warning polling ---
        link(scope, element, attrs, ctrls, _transclude) {
            const summernoteController = ctrls[0];
            const ngModel = ctrls[1];
            scope.model = ngModel;
            let isCreateScheduled = false;
            let summernoteCreated = false;
            let openMsgTimer = null;
            let mentionSyncTimer = null;
            let warningApplyTimer = null;
            if (!scope.qmId) {
                scope.qmId = '_' + Math.random().toString(36).substring(2, 11);
            }
            const summernoteElement = element.find('.summernote');
            scope.allowedFileTypes = '.doc,.docx,.rtf,.txt,.pdf,.htm,.html';
            scope.insert = function (text) {
                summernoteElement.summernote('editor.saveRange');
                summernoteElement.summernote('editor.restoreRange');
                summernoteElement.summernote('editor.focus');
                if (summernoteIsEmpty(summernoteElement)) {
                    summernoteElement.summernote('code', text);
                }
                else {
                    summernoteElement.summernote('pasteHTML', text);
                }
                summernoteElement.summernote('editor.focus');
            };
            scope.openMsg = function () {
                if (openMsgTimer) {
                    $timeout.cancel(openMsgTimer);
                }
                scope.open = true;
                openMsgTimer = $timeout(() => {
                    openMsgTimer = null;
                    scope.open = false;
                    $qui.scopeApply(scope);
                }, OPEN_MSG_MS, false);
            };
            const scheduleWarningStyleApply = () => {
                if (warningApplyTimer) {
                    $timeout.cancel(warningApplyTimer);
                }
                warningApplyTimer = $timeout(() => {
                    warningApplyTimer = null;
                    scope.setWarningStyle();
                }, 0, false);
            };
            /** First stable `ngModel.$viewValue` read (deep watch) then init editor once via controller. */
            const createSummernote = () => {
                if (summernoteCreated || isCreateScheduled) {
                    return;
                }
                isCreateScheduled = true;
                const config = createOptions();
                const clearWatch = scope.$watch(() => ngModel.$viewValue, (value) => {
                    clearWatch();
                    summernoteController.render(scope, summernoteElement, ngModel, config);
                    summernoteCreated = true;
                    isCreateScheduled = false;
                    if (value && value.length > 0) {
                        summernoteElement.summernote('code', value);
                    }
                    if (scope.qmWarning !== undefined) {
                        scheduleWarningStyleApply();
                    }
                }, true);
            };
            if (angular.isDefined(scope.qmCreate)) {
                scope.qmCreate = function () {
                    createSummernote();
                };
            }
            else {
                createSummernote();
            }
            if (angular.isDefined(attrs.qmFlush)) {
                scope.qmFlush = function () {
                    summernoteController.flush();
                };
            }
            if (angular.isDefined(attrs.qmFocus)) {
                scope.qmFocus = function () {
                    summernoteController.focus();
                };
            }
            /** Builds Summernote options: default toolbar + optional @mentions + import dropdown button. */
            function createOptions() {
                let height = 300;
                if (angular.isDefined(scope.qmHeight)) {
                    height = scope.qmHeight;
                }
                let options = {};
                if (angular.isDefined(attrs.config)) {
                    options = scope.config || {};
                }
                else {
                    options = {
                        placeholder: attrs.placeholder,
                        height,
                        focus: false,
                        airMode: false,
                        lang: 'de-DE',
                        disableResizeEditor: false,
                        toolbar: [
                            ['font', ['bold', 'italic', 'underline', 'color', 'clear', 'style']],
                            ['alignment', ['ul', 'ol']]
                        ],
                        styleTags: ['p', 'h1', 'h2', 'h3', 'h4', 'h5'],
                        popover: {
                            image: [
                                ['float', ['floatLeft', 'floatRight', 'floatNone']],
                                ['remove', ['removeMedia']]
                            ]
                        },
                        hint: []
                    };
                }
                // Enable mentions when the attribute is present, even if it is an empty string (boolean-style attr).
                if (angular.isDefined(attrs.qmMentions)) {
                    options.hint = {
                        mentions: createMentionList(),
                        match: /\B@(\w*)/i,
                        search(keyword, callback) {
                            // Resolve mention source lazily so async-loaded participant lists are reflected immediately.
                            const mentionSource = createMentionList();
                            callback($.grep(mentionSource, function (item) {
                                const kw = keyword.toLowerCase();
                                return item.toLowerCase().includes(kw);
                            }));
                        },
                        content(item) {
                            if (!scope.qmParticipants) {
                                scope.qmParticipants = [];
                            }
                            const list = scope.qmClientList;
                            if (list) {
                                // Resolve index against the latest mention projection (list can change after editor init).
                                const mentionIndex = createMentionList().indexOf(item);
                                if (mentionIndex > -1 && list[mentionIndex]) {
                                    scope.qmParticipants.push(list[mentionIndex].value);
                                }
                            }
                            if (mentionSyncTimer) {
                                $timeout.cancel(mentionSyncTimer);
                            }
                            mentionSyncTimer = $timeout(() => {
                                mentionSyncTimer = null;
                                if (summernoteController.updateNgModel) {
                                    summernoteController.updateNgModel();
                                }
                                $qui.scopeApply(scope);
                            }, MENTION_SYNC_MS, false);
                            const lngTagClient = '(' + $languageService.translate(21002000, 'Klient') + ')';
                            const lngTagEmployee = '(' + $languageService.translate(20000235, 'Mitarbeiter') + ')';
                            if (item.includes(lngTagClient)) {
                                item = item.replace(lngTagClient, '');
                            }
                            else {
                                item = item.replace(lngTagEmployee, '');
                            }
                            return item;
                        }
                    };
                }
                options.buttons = {
                    importDropDown() {
                        const ui = summernoteUi();
                        return ui
                            .buttonGroup([
                            ui.button({
                                contents: $languageService.translate(20000310, 'Textbaustein'),
                                click: () => {
                                    scope.openTextblock();
                                }
                            }),
                            ui.button({
                                className: 'dropdown-toggle',
                                contents: '<span class="fa fa-folder-open"></span>' +
                                    $languageService.translate(20000309, 'Einfügen') +
                                    ' <span class="caret"></span>',
                                tooltip: $languageService.translate(20000309, 'Einfügen') +
                                    ' ' +
                                    $languageService.translate(20000067, 'von') +
                                    '...',
                                data: {
                                    toggle: 'dropdown'
                                }
                            }),
                            ui.dropdown({
                                className: 'drop-default summernote-list',
                                contents: '<div class="btn-group" style=width:max-content>' +
                                    '<div class="summernote-dropdown-item time"><i class="fa fa-clock-o"></i> ' +
                                    $languageService.translate(20000311, 'Zeitstempel') +
                                    '</div>' +
                                    '<hr style="margin:5px">' +
                                    '<div class="summernote-dropdown-item template"><i class="fa fa-file-text-o"></i> ' +
                                    $languageService.translate(20000312, 'Dokumentvorlage') +
                                    '</div>' +
                                    '<div class="summernote-dropdown-item upload"><i class="fa fa-upload"></i> ' +
                                    $languageService.translate(20000313, 'Datei') +
                                    '</div>' +
                                    '</div>',
                                callback($dropdown) {
                                    $dropdown
                                        .find('.block')
                                        .off(IMPORT_DROPDOWN_CLICK_NS)
                                        .on(IMPORT_DROPDOWN_CLICK_NS, () => {
                                        scope.openTextblock();
                                    });
                                    $dropdown
                                        .find('.template')
                                        .off(IMPORT_DROPDOWN_CLICK_NS)
                                        .on(IMPORT_DROPDOWN_CLICK_NS, () => {
                                        scope.openTexttemplate();
                                    });
                                    $dropdown
                                        .find('.time')
                                        .off(IMPORT_DROPDOWN_CLICK_NS)
                                        .on(IMPORT_DROPDOWN_CLICK_NS, () => {
                                        scope.insert('---' +
                                            moment().format('DD.MM.YYYY HH:mm:ss') +
                                            ' ' +
                                            $('#session').data().fullName +
                                            '---');
                                    });
                                    $dropdown
                                        .find('.upload')
                                        .off(IMPORT_DROPDOWN_CLICK_NS)
                                        .on(IMPORT_DROPDOWN_CLICK_NS, () => {
                                        $('#file_' + scope.qmId).trigger('click');
                                    });
                                }
                            })
                        ])
                            .render();
                    }
                };
                options.toolbar = options.toolbar || [];
                options.toolbar.push(['costum', ['importDropDown']]);
                return options;
            }
            // Shallow signature watch avoids deep `JSON.stringify` on large file payloads each digest.
            scope.$watch(() => fileInsertSignature(scope.fileToInsert), (newSig, oldSig) => {
                const newVal = scope.fileToInsert;
                if (!newSig || newSig === oldSig) {
                    if ((newVal === null || newVal === void 0 ? void 0 : newVal.length) === 0) {
                        scope.fileToInsert = [];
                    }
                    return;
                }
                if (!newVal || newVal.length === 0) {
                    scope.fileToInsert = [];
                    return;
                }
                const suffix = newVal[0].name.split('.').pop() || '';
                const lower = suffix.toLowerCase();
                if (lower === 'txt' || lower === 'htm' || lower === 'html') {
                    scope.insert(atob(newVal[0].base64));
                    scope.fileToInsert = [];
                    return;
                }
                scope.converting = true;
                mediaService
                    .convertToHtml(newVal[0].base64, suffix)
                    .then((data) => {
                    scope.insert(data);
                })
                    .finally(() => {
                    scope.converting = false;
                });
                scope.fileToInsert = [];
            });
            /** Display strings for Summernote hint plugin (parallel index with `qmClientList`). */
            function createMentionList() {
                if (!scope.qmClientList) {
                    return [];
                }
                return scope.qmClientList.map(function (obj) {
                    return obj.text;
                });
            }
            scope.clearActive = function (group) {
                scope.qmSmartActions.ignoredKeys = scope.qmSmartActions.ignoredKeys.concat(scope.qmSmartActions.activeKeys[group]);
                scope.qmSmartActions.activeKeys[group] = [];
                if (scope.getActiveKeywordGroupCount() === 0) {
                    scope.openMenu();
                }
            };
            scope.getActiveKeywordGroupCount = function () {
                let count = 0;
                for (const prop in scope.qmSmartActions.activeKeys) {
                    if (scope.qmSmartActions.activeKeys[prop].length > 0) {
                        count++;
                    }
                }
                return count;
            };
            scope.getActiveKeyWords = function (group) {
                const keys = scope.qmSmartActions.activeKeys[group];
                if (keys && keys.length > 0) {
                    return keys.join(', ');
                }
                return '';
            };
            scope.menuOpen = false;
            scope.openMenu = function () {
                const menu = document.getElementById('sadd' + scope.qmId);
                if (!menu) {
                    return;
                }
                menu.classList.toggle('sa-show');
                scope.menuOpen = !scope.menuOpen;
            };
            scope.$watch('qmWarning', () => {
                scope.lastWarningValue = scope.qmWarning;
                scheduleWarningStyleApply();
            });
            scope.setWarningStyle = function () {
                if (scope.qmWarning) {
                    element.find('.note-editor').attr('style', 'border-color: #f0ad4e !important;');
                    element.find('.note-editor').find('.note-toolbar').attr('style', 'background-color: #ffcf8b !important;');
                }
                else {
                    element.find('.note-editor').attr('style', 'unset;');
                    element.find('.note-editor').find('.note-toolbar').attr('style', 'unset');
                }
            };
            scope.snLocation = location.hash;
            scope.$on('$destroy', () => {
                if (openMsgTimer) {
                    $timeout.cancel(openMsgTimer);
                    openMsgTimer = null;
                }
                if (mentionSyncTimer) {
                    $timeout.cancel(mentionSyncTimer);
                    mentionSyncTimer = null;
                }
                if (warningApplyTimer) {
                    $timeout.cancel(warningApplyTimer);
                    warningApplyTimer = null;
                }
            });
            if (scope.qmWarning !== undefined) {
                scheduleWarningStyleApply();
            }
        }
    };
}
// registration.
angular.module('qmc-ui').directive('qmSummernote', [
    'QmcLanguageService',
    '$qui',
    'UserService',
    'QmcMediaService',
    '$timeout',
    qmSummernoteDirective
]);
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputText = class qmInputText {
            constructor() {
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmPlaceholder: '@',
                    qmChange: '=',
                    qmIcon: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmClass: '@',
                    qmValue: '=',
                    qmRequired: '@',
                    qmMinLength: '@',
                    qmMaxLength: '@',
                    qmDisabled: '=',
                    qmPattern: '@',
                    qmTrim: '@',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@',
                    qmId: '@'
                };
                this.templateUrl = 'Input/Text';
                this.link = (scope, element, attrs) => {
                    if (scope.qmId == (null || undefined)) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                };
            }
        };
        qmInputText = __decorate([
            QMC.Directive('QMC.Input', 'qmInputText', [])
        ], qmInputText);
        Input.qmInputText = qmInputText;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let InputTextblock = class InputTextblock {
            constructor(mediaService, lng, $qui, filter, $sce) {
                this.mediaService = mediaService;
                this.lng = lng;
                this.$qui = $qui;
                this.filter = filter;
                this.$sce = $sce;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmId: '@',
                    qmOpen: '=',
                    qmInsert: '&'
                };
                this.templateUrl = 'Input/Textblock';
                this.link = (scope) => {
                    scope.formatted = false;
                    scope.inline = true;
                    const storageName = 'TextBlockCache';
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    if (QMC.Common.personalLocalStorage.getItem(storageName + 'Format')) {
                        const cache = JSON.parse(QMC.Common.personalLocalStorage.getItem(storageName + 'Format'));
                        scope.formatted = cache.formatted;
                        scope.inline = cache.inline;
                    }
                    scope.setFormatCache = () => {
                        QMC.Common.personalLocalStorage.setItem(storageName + 'Format', JSON.stringify({
                            formatted: scope.formatted,
                            inline: scope.inline
                        }));
                    };
                    scope.laLabel = {
                        caption: this.lng.translate(20000074, 'Lebensbereich'),
                        subCaption: this.lng.translate(20016192, 'Unter-Lebensbereich')
                    };
                    scope.qmOpen = () => {
                        $('#textBlockModal_' + scope.qmId).modal('show');
                        initModal();
                        scope.initLASelect();
                    };
                    const initModal = () => {
                        var _a;
                        scope.loading = true;
                        scope.searchText = '';
                        ((_a = scope.textblocks) !== null && _a !== void 0 ? _a : []).forEach((item) => item.isChecked = false);
                        scope.setChecked();
                        const storage = sessionStorage.getItem(storageName);
                        // if cache is not set or older than five minutes, load data form server
                        if (!storage || (storage !== 'loading' && (new Date().getTime() - moment(JSON.parse(storage).timestamp).toDate().getTime() > 5 * 60 * 1000))) {
                            loadData();
                        }
                        else if (storage === 'loading') {
                            setTimeout(() => { initModal(); }, 500);
                        }
                        else {
                            scope.textblocks = JSON.parse(storage).data;
                            for (const block of scope.textblocks) {
                                block.isChecked = false;
                            }
                            scope.loading = false;
                        }
                        this.$qui.scopeApply(scope);
                    };
                    const loadData = () => {
                        sessionStorage.setItem(storageName, 'loading');
                        this.mediaService.getTextBlocks().then((data) => {
                            scope.textblocks = data;
                        }).catch(() => {
                            scope.textblocks = [];
                        }).finally(() => {
                            scope.loading = false;
                            sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), data: scope.textblocks }));
                        });
                    };
                    scope.getFilteredData = () => {
                        let blocks = this.filter(scope.textblocks, scope.searchText);
                        if (scope.livingAreaId && scope.livingAreaId !== '00000000-0000-0000-0000-000000000000') {
                            blocks = blocks.filter(x => x.livingAreaId === scope.livingAreaId);
                            if (scope.subLivingAreaId && scope.subLivingAreaId !== '00000000-0000-0000-0000-000000000000') {
                                blocks = blocks.filter(x => x.subLivingAreaId === scope.subLivingAreaId);
                            }
                        }
                        return blocks;
                    };
                    scope.addCheckedTextBlocks = () => {
                        const result = [];
                        for (const block of scope.textblocks) {
                            if (block.isChecked) {
                                if (scope.formatted) {
                                    result.push(scope.inline ? this.stripParagraph(block.text) : block.text);
                                }
                                else {
                                    result.push(scope.inline ? block.previewText.replace(/(?:\r\n|\r|\n)/g, '<br>') : '<span><p>' + block.previewText.replace(/(?:\r\n|\r|\n)/g, '<br>') + '</p></span>');
                                }
                            }
                        }
                        scope.qmInsert({ text: result.join(' ') });
                    };
                    scope.setChecked = () => {
                        var _a;
                        scope.selected = ((_a = scope.textblocks) !== null && _a !== void 0 ? _a : []).filter(x => x.isChecked).length;
                    };
                    scope.trustHtml = (html) => {
                        return this.$sce.trustAsHtml(this.stripParagraph(html));
                    };
                    scope.showPreview = (textBlock) => {
                        scope.textBlockPreview = textBlock;
                        $(`#previewTextDialog_${scope.qmId}`).modal('show');
                        scope.showPreviewFormatted = angular.copy(scope.formatted);
                    };
                };
            }
            stripParagraph(input) {
                var _a;
                //only strip surrounding first paragraph, let others in place
                const div = document.createElement('div');
                div.innerHTML = input;
                let first = (_a = $(div).find('p:first')[0]) === null || _a === void 0 ? void 0 : _a.outerHTML;
                if (!first)
                    return input;
                first = first.replace(/(<p)/, '<span').replace(/<\/p([^<\/p]*)$/, '<\/span$1');
                $(div).find('p:first')[0].outerHTML = first;
                return div.innerHTML;
            }
        };
        InputTextblock = __decorate([
            QMC.Directive('QMC.Input', 'qmInputTextblock', ['QmcMediaService', 'QmcLanguageService', '$qui', 'filterFilter', '$sce'])
        ], InputTextblock);
        Input.InputTextblock = InputTextblock;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let InputTexttemplate = class InputTexttemplate {
            constructor(mediaService, lng, $qui, filter) {
                this.mediaService = mediaService;
                this.lng = lng;
                this.$qui = $qui;
                this.filter = filter;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmId: '@',
                    qmOpen: '=',
                    qmInsert: '&'
                };
                this.templateUrl = 'Input/Texttemplate';
                this.link = (scope) => {
                    const storageName = 'TextTemplateCache';
                    if (!scope.qmId) {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    scope.wvLabel = {
                        caption: this.lng.translate(21006002, 'Hauptkategorie'),
                        subCaption: this.lng.translate(21006003, 'Unterkategorie')
                    };
                    scope.qmOpen = () => {
                        $('#textTemplateModal_' + scope.qmId).modal('show');
                        initModal();
                        scope.initSelect();
                    };
                    const initModal = () => {
                        scope.loading = true;
                        const storage = sessionStorage.getItem(storageName);
                        // if cache is not set or older than five minutes, load data form server
                        if (!storage || (storage !== 'loading' && (new Date().getTime() - moment(JSON.parse(storage).timestamp).toDate().getTime() > 5 * 60 * 1000))) {
                            loadData();
                        }
                        else if (storage === 'loading') {
                            setTimeout(() => { initModal(); }, 500);
                        }
                        else {
                            scope.texttemplates = JSON.parse(storage).data;
                            scope.loading = false;
                        }
                        this.$qui.scopeApply(scope);
                    };
                    const loadData = () => {
                        sessionStorage.setItem(storageName, 'loading');
                        this.mediaService.getTextTemplates().then((data) => {
                            scope.texttemplates = data;
                        }).catch(() => {
                            scope.texttemplates = [];
                        }).finally(() => {
                            scope.loading = false;
                            sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), data: scope.texttemplates }));
                        });
                    };
                    scope.getFilteredData = () => {
                        let blocks = this.filter(scope.texttemplates, scope.searchText);
                        if (scope.categoryId && scope.categoryId !== '00000000-0000-0000-0000-000000000000') {
                            blocks = blocks.filter(x => x.categoryId === scope.categoryId);
                            if (scope.subCategoryId && scope.subCategoryId !== '00000000-0000-0000-0000-000000000000') {
                                blocks = blocks.filter(x => x.subCategoryId === scope.subCategoryId);
                            }
                        }
                        return blocks;
                    };
                    scope.add = (item) => {
                        scope.loading = true;
                        this.mediaService.getTextTemplateContent(item.mediaId).then((content) => {
                            scope.qmInsert({ text: content });
                        }).finally(() => {
                            scope.loading = false;
                            $('#textTemplateModal_' + scope.qmId).modal('hide');
                        });
                    };
                };
            }
        };
        InputTexttemplate = __decorate([
            QMC.Directive('QMC.Input', 'qmInputTexttemplate', ['QmcMediaService', 'QmcLanguageService', '$qui', 'filterFilter'])
        ], InputTexttemplate);
        Input.InputTexttemplate = InputTexttemplate;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let qmInputTime = class qmInputTime {
            constructor($qui) {
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmModel: '=',
                    qmDisplayModel: '@',
                    qmPlaceholder: '=',
                    qmNoRow: '@',
                    qmLabel: '@',
                    qmName: '@',
                    qmRequired: '@',
                    qmInit: '@',
                    qmIcon: '@',
                    qmId: '@',
                    qmDisabled: '=',
                    qmEdit: '=',
                    qmValidate: '=',
                    qmValidateMessage: '@'
                };
                this.templateUrl = () => {
                    return (new qmDeviceSet()).isMobile() ? 'Input/Mobile/Time' : 'Input/Time';
                };
                this.link = (scope, element, attrs) => {
                    if (!scope.qmId || scope.qmId === 'd.id') {
                        scope.qmId = '_' + Math.random().toString(36).substr(2, 9);
                    }
                    const mobile = (new qmDeviceSet()).isMobile();
                    scope.$watch('qmDisplayModel', (newVal, oldVal) => {
                        if (newVal === oldVal || (!newVal && !oldVal))
                            return;
                        if (newVal && newVal.length) {
                            // make sure to only allaw valid time inputs
                            if (scope.qmDisplayModel && scope.qmDisplayModel.length > 0) {
                                const splitted = scope.qmDisplayModel ? scope.qmDisplayModel.split(':') : [0, 0];
                                if (splitted.length === 2) {
                                    if (splitted[0] > 23) {
                                        splitted[0] = 23;
                                        splitted[1] = 59;
                                    }
                                    splitted[1] = parseInt(splitted[1]) > 59 ? 59 : splitted[1];
                                }
                                scope.qmDisplayModel = splitted[0] + ":" + splitted[1];
                            }
                        }
                        // if field is required but got deleted, restore previous state to ensure equirement status
                        else if (!newVal && scope.qmRequired) {
                            scope.qmDisplayModel = oldVal;
                        }
                    });
                    scope.$watch('qmModel', (oldVal, newVal) => {
                        if (oldVal === newVal || !scope.qmModel)
                            return;
                        if (!(scope.qmModel instanceof Date))
                            scope.qmModel = moment(newVal).toDate();
                        scope.qmModel.setSeconds(0);
                        scope.qmModel.setMilliseconds(0);
                    });
                    this.$qui.timepicker();
                    if (scope.qmModel != (null || undefined)) {
                        if (!(scope.qmModel instanceof Date))
                            scope.qmModel = moment(scope.qmModel).toDate();
                        scope.qmModel.setSeconds(0);
                        scope.qmModel.setMilliseconds(0);
                    }
                    if (mobile.length == 0) {
                        scope.$watch('qmModel', () => {
                            scope.qmDisplayModel = null;
                            if (scope.qmModel != (null || undefined)) {
                                scope.qmDisplayModel = moment(scope.qmModel).format('HH:mm');
                            }
                        });
                        $('.clockpicker').clockpicker().find('input').change(function (event) {
                            event.stopPropagation();
                            scope.qmInit = scope.qmDisplayModel;
                            const time = scope.qmDisplayModel ? scope.qmDisplayModel.split(':') : [0, 0];
                            const model = new Date();
                            if (scope.qmModel == (null || undefined || 'Invalid Date'))
                                scope.qmModel = new Date();
                            if (moment(scope.qmDisplayModel, 'HH:mm').isValid()) {
                                if (time[0] >= 24)
                                    time[0] = 23;
                                if (time[1] >= 60)
                                    time[1] = 59;
                                scope.qmDisplayModel = time[0] + ":" + time[1];
                                model.setHours(time[0], time[1], 0, 0);
                                scope.$apply(function () {
                                    scope.qmModel = model;
                                });
                                setTimeout(function () {
                                    $('.clockpicker').clockpicker('hide');
                                }, 100);
                            }
                        });
                    }
                    if (attrs.hasOwnProperty("qmNoRow")) {
                        element.removeClass("row");
                        element.children(".col-xs-12").removeClass("col-xs-12");
                    }
                };
            }
        };
        qmInputTime = __decorate([
            QMC.Directive('QMC.Input', 'qmInputTime', ['$qui'])
        ], qmInputTime);
        Input.qmInputTime = qmInputTime;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Input;
    (function (Input) {
        let WvSelect = class WvSelect {
            constructor(wvService, $qui) {
                this.wvService = wvService;
                this.$qui = $qui;
                this.restrict = 'EA';
                this.replace = true;
                this.scope = {
                    qmInit: '=',
                    qmWvId: '=',
                    qmSubWvId: '=',
                    qmSelectedWvId: '=',
                    qmSelectedSubWvId: '=',
                    qmLabel: '=?'
                };
                this.templateUrl = 'Input/WvSelect';
                this.link = (scope) => {
                    const storageName = `WvSelectCache_${scope.qmWvId}_${scope.qmSubWvId}`;
                    if (!scope.qmLabel)
                        scope.qmLabel = {
                            caption: 'Bereich',
                            subCaption: 'Unterbereich'
                        };
                    else if (typeof scope.qmLabel === 'string')
                        scope.qmLabel = { caption: scope.qmLabel };
                    const init = () => {
                        var _a, _b;
                        scope.loading = true;
                        scope.subLoading = true;
                        scope.qmSelectedWvId = undefined;
                        scope.qmSelectedSubWvId = undefined;
                        const storage = sessionStorage.getItem(storageName);
                        // if cache is not set or older than five minutes, load data form server
                        if (!storage || (storage !== 'loading' && (new Date().getTime() - moment(JSON.parse(storage).timestamp).toDate().getTime() > 5 * 60 * 1000))) {
                            loadData();
                        }
                        else if (storage === 'loading') {
                            setTimeout(() => { init(); }, 500);
                        }
                        else {
                            scope.wvs = (_a = JSON.parse(storage).wvs) !== null && _a !== void 0 ? _a : [];
                            scope.subWvs = (_b = JSON.parse(storage).subWvs) !== null && _b !== void 0 ? _b : {};
                            scope.loading = false;
                            scope.subLoading = false;
                        }
                        scope.$watch('qmSelectedWvId', () => {
                            scope.qmSelectedSubWvId = null;
                            scope.subWvMap = [];
                            setTimeout(() => {
                                if (scope.subWvs && scope.qmSelectedWvId && scope.subWvs[scope.qmSelectedWvId]) {
                                    scope.subWvMap = scope.subWvs[scope.qmSelectedWvId].map(x => ({ text: x.name, value: x.objectId }));
                                    scope.subWvMap.unshift({ text: '' });
                                }
                                this.$qui.scopeApply(scope);
                            }, 50);
                        });
                        scope.init = true;
                    };
                    const loadData = () => {
                        sessionStorage.setItem(storageName, 'loading');
                        this.wvService.getWvList(scope.qmWvId).then((data) => {
                            scope.wvs = data.map(x => ({ text: x.name, value: x.objectId }));
                            scope.wvs.unshift({ text: '' });
                            if (scope.qmSubWvId)
                                this.wvService.getSubWvListForParent(scope.qmSubWvId, scope.qmWvId).then((dataSub) => {
                                    scope.subWvs = dataSub;
                                }).catch(() => {
                                    scope.subWvs = {};
                                }).finally(() => {
                                    scope.subLoading = false;
                                    sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), wvs: scope.wvs, subWvs: scope.subWvs }));
                                });
                        }).catch(() => {
                            scope.wvs = [];
                        }).finally(() => {
                            scope.loading = false;
                            sessionStorage.setItem(storageName, JSON.stringify({ timestamp: new Date(), wvs: scope.wvs, subWvs: scope.subWvs }));
                        });
                    };
                    scope.qmInit = () => {
                        init();
                    };
                    if (!scope.qmInit)
                        init();
                };
            }
        };
        WvSelect = __decorate([
            QMC.Directive('QMC.Input', 'qmWvSelect', ['QmcWvService', '$qui'])
        ], WvSelect);
        Input.WvSelect = WvSelect;
    })(Input = QMC.Input || (QMC.Input = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../maps/qmc.input.js.map
